"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4172],{

/***/ 37531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgV = function SvgV(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 26,
        height: 20,
        viewBox: "0 0 26 20"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M9 14 3 8l-3 3 6 6 3 3 3-3L26 3l-3-3z"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgV);


/***/ }),

/***/ 44133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AssetPartComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/video/video-component.js + 1 modules
var video_component = __webpack_require__(3773);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/core/one-pager/asset-part/asset-part-component.scss.js

var _defaultExport = new String(".asset-part-component.jsx-66cf28cb47c773ef{width:100%;height:100%;video {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    &.half-width {\n      display: flex;\n      justify-content: flex-end;\n    }\n  }");
_defaultExport.__hash = "66cf28cb47c773ef";
/* harmony default export */ var asset_part_component_scss = (_defaultExport);

;// CONCATENATED MODULE: ./components/core/one-pager/asset-part/asset-part-component.js









var AssetPartComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(AssetPartComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(AssetPartComponent);
    function AssetPartComponent() {
        (0,_class_call_check/* default */.Z)(this, AssetPartComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(AssetPartComponent, [
        {
            key: "getVideoType",
            value: function getVideoType(videoUrl) {
                return videoUrl.split(".").pop();
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, playsInline = _props.playsInline, autoPlay = _props.autoPlay, muted = _props.muted, loop = _props.loop, theme = _props.theme;
                var _assetProps = this.props.assetProps, formats = _assetProps.formats, poster = _assetProps.poster;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(asset_part_component_scss.__hash) + " " + "asset-part-component ".concat(theme),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(video_component/* default */.Z, {
                            formats: formats,
                            loop: loop,
                            muted: muted,
                            poster: poster,
                            playsInline: playsInline,
                            autoPlay: autoPlay
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: asset_part_component_scss.__hash,
                            children: asset_part_component_scss
                        })
                    ]
                });
            }
        }
    ]);
    return AssetPartComponent;
}(react.PureComponent);

AssetPartComponent.defaultProps = {
    playsInline: true,
    autoPlay: true,
    muted: true,
    loop: true
};


/***/ }),

/***/ 93030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CompetitorsComparisonTableComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/segments/competitors-comparison-table/competitors-comparison-table-component.scss.js


var StyledCompetitorsComparisonTableComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e98igvu0"
})("text-align:center;margin-top:50px;.competitors-comparison-title{font-size:2.2vw;margin-bottom:20px;font-weight:500;}.competitors-comparison-subtitle{font-size:1.4vw;font-weight:300;line-height:1.3;margin-bottom:20px;}.table-wrapper{padding:50px 100px;.table-header{padding-bottom:20px !important;.vs-cell{font-size:1.463rem;font-weight:400;}}.table-row{display:flex;padding:0px 30px;.table-cell{flex:1 1;height:80px;display:flex;align-items:center;justify-content:center;}.first-cell{justify-content:left;}.monday-logo-wrapper{width:100%;img{width:80%;max-width:200px;}}.competitor-logo-wrapper{width:100%;img{width:80%;max-width:200px;}}}}.mobile-table-wrapper{display:none;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.competitors-comparison-titles-wrapper{padding:0px 20px;width:80%;margin:0px auto;.competitors-comparison-title{font-size:1.575rem;text-align:left;line-height:1.3;}.competitors-comparison-subtitle{font-size:0.875rem;text-align:left;line-height:1.5;}}.table-wrapper{display:none;}.mobile-table-wrapper{display:block;margin:50px 0px;.table-header{display:flex;padding:10px 0px;.monday-logo-wrapper,.competitor-logo-wrapper{width:100%;img{width:80%;}}}}}");

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
;// CONCATENATED MODULE: ./components/segments/competitors-comparison-table/comparison-feature/comparison-feature-component.scss.js


var StyledComparisonFeatureComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "egkw7zd0"
})(".table-row{&.even{background:#ecf4f8;border-radius:40px;}&.big-texts{.table-cell:not(.first-cell){font-size:1.375rem;}}}.mobile-table-row{display:none;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.table-row{display:none;}.mobile-table-row{display:block;.feature-title{display:flex;height:40px;align-items:center;justify-content:center;}.feature-cells{display:flex;height:50px;align-items:center;background:#ecf4f8;border-radius:30px;margin:0px 5vw;.table-cell{flex:1 0;}}}}");

// EXTERNAL MODULE: ./static/svg/competitors-template/v.svg
var v = __webpack_require__(37531);
;// CONCATENATED MODULE: ./static/svg/competitors-template/x.svg
var _g;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgX = function SvgX(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        viewBox: "0 0 25 25"
    }, props), _g || (_g = /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "#FF3D57",
        strokeLinecap: "square",
        strokeWidth: 4.5
    }, /*#__PURE__*/ react.createElement("path", {
        d: "m4 4 17 17M21 4 4 21"
    }))));
};
/* harmony default export */ var x = (SvgX);

;// CONCATENATED MODULE: ./components/segments/competitors-comparison-table/comparison-feature/comparison-feature-component.js









var ComparisonFeatureComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ComparisonFeatureComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ComparisonFeatureComponent);
    function ComparisonFeatureComponent() {
        (0,_class_call_check/* default */.Z)(this, ComparisonFeatureComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ComparisonFeatureComponent, [
        {
            key: "renderFeatureValueContnet",
            value: function renderFeatureValueContnet(value) {
                if (value === "true") return /*#__PURE__*/ (0,jsx_runtime.jsx)(v/* default */.Z, {
                    fill: "#00D647"
                });
                if (value === "false") return /*#__PURE__*/ (0,jsx_runtime.jsx)(x, {});
                return value;
            }
        },
        {
            key: "renderFeatureValue",
            value: function renderFeatureValue(value) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "feature-value",
                    children: this.renderFeatureValueContnet(value)
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, monday = _props.monday, competitor = _props.competitor, index = _props.index, bigTexts = _props.bigTexts;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledComparisonFeatureComponent, {
                    className: "table-row-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "table-row table-feature ".concat(index % 2 == 0 ? "even" : "odd", " ").concat(bigTexts ? "big-texts" : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "table-cell first-cell",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "table-cell",
                                    children: this.renderFeatureValue(monday)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "table-cell"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "table-cell",
                                    children: this.renderFeatureValue(competitor)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "table-cell"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mobile-table-row ".concat(bigTexts ? "big-texts" : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "feature-title",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "feature-cells",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell",
                                            children: this.renderFeatureValue(monday)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell",
                                            children: this.renderFeatureValue(competitor)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return ComparisonFeatureComponent;
}(react.PureComponent);

ComparisonFeatureComponent.defaultProps = {
    title: null,
    monday: null,
    competitor: null
};

;// CONCATENATED MODULE: ./components/segments/competitors-comparison-table/competitors-comparison-table-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var CompetitorsComparisonTableComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CompetitorsComparisonTableComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CompetitorsComparisonTableComponent);
    function CompetitorsComparisonTableComponent() {
        (0,_class_call_check/* default */.Z)(this, CompetitorsComparisonTableComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CompetitorsComparisonTableComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, subtitle = _props.subtitle, features = _props.features, mondayLogo = _props.mondayLogo, competitorLogo = _props.competitorLogo;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCompetitorsComparisonTableComponent, {
                    className: "competitors-comparison-table",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "competitors-comparison-titles-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "competitors-comparison-title",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "competitors-comparison-subtitle",
                                    children: subtitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "table-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "table-row table-header",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "monday-logo-wrapper",
                                                style: {
                                                    height: "".concat(mondayLogo.height, "%")
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                    className: "monday-logo",
                                                    src: "/static/img/monday-logos/monday_logo_short.png"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell vs-cell",
                                            children: "vs."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell",
                                            children: competitorLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "competitor-logo-wrapper",
                                                style: {
                                                    height: "".concat(competitorLogo.height, "%")
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                    className: "competitor-logo",
                                                    src: competitorLogo.src
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell"
                                        })
                                    ]
                                }),
                                features.map(function(feature, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparisonFeatureComponent, _object_spread_props(_object_spread({}, feature.props), {
                                        index: i
                                    }), i);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mobile-table-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "table-header",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "monday-logo-wrapper",
                                                style: {
                                                    height: "".concat(mondayLogo.height, "%")
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                    className: "monday-logo",
                                                    src: "/static/img/monday-logos/monday_logo_short.png"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell",
                                            children: competitorLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "competitor-logo-wrapper",
                                                style: {
                                                    height: "".concat(competitorLogo.height, "%")
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                    className: "competitor-logo",
                                                    src: competitorLogo.src
                                                })
                                            })
                                        })
                                    ]
                                }),
                                features.map(function(feature, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparisonFeatureComponent, _object_spread_props(_object_spread({}, feature.props), {
                                        index: i
                                    }), i);
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return CompetitorsComparisonTableComponent;
}(react.PureComponent);

CompetitorsComparisonTableComponent.defaultProps = {
    features: [],
    mondayLogo: {}
};


/***/ }),

/***/ 60500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ArticleTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/addons/core-addons/core-addons-component.js + 8 modules
var core_addons_component = __webpack_require__(48124);
// EXTERNAL MODULE: ./constants/element-ids.js
var element_ids = __webpack_require__(53219);
// EXTERNAL MODULE: ./components/templates/base-template.js + 50 modules
var base_template = __webpack_require__(44723);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/asset-strip/asset-strip-component.scss.js



var StyledAssetStripComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ebjwg9m0"
})("position:relative;width:100vw;max-width:100%;overflow:hidden;img{min-width:100%;}.asset-strip-content{position:absolute;top:0;bottom:0;right:0;left:0;display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center;.strip-signup-wrapper{margin-top:32px;}.strip-title{color:", colors/* default.white */.Z.white, ";font-size:2.7rem;font-weight:700;margin-bottom:24px;padding:0 48px;}.strip-subtitle{color:", colors/* default.white */.Z.white, ";font-size:1.375rem;margin-bottom:24px;padding:0 48px;}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.asset-strip-content{.strip-title{font-size:2.25rem;margin-bottom:24px;padding:0 24px;}.strip-subtitle{font-size:1.375rem;margin-bottom:24px;padding:0 24px;}}}@media (max-width:", vp_sizes/* SMALL_MOBILE_QUERY_MAX_WIDTH */.cb, "){.asset-strip-content{.strip-title{font-size:1.75rem;}.strip-subtitle{font-size:1.125rem;}}}");

;// CONCATENATED MODULE: ./components/core/asset-strip/asset-strip-component.js









var AssetStripComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(AssetStripComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(AssetStripComponent);
    function AssetStripComponent() {
        (0,_class_call_check/* default */.Z)(this, AssetStripComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(AssetStripComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, asset = _props.asset, title = _props.title, subtitle = _props.subtitle, height = _props.height, preventSignup = _props.preventSignup, signupFocusOnLoad = _props.signupFocusOnLoad;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAssetStripComponent, {
                    className: "asset-strip-component",
                    style: {
                        height: height
                    },
                    children: [
                        asset && /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            src: asset.src,
                            alt: asset.alt
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "asset-strip-content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "strip-title",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "strip-subtitle",
                                    children: subtitle
                                }),
                                !preventSignup && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "strip-signup-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                                        focusOnLoad: signupFocusOnLoad
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return AssetStripComponent;
}(react.PureComponent);

AssetStripComponent.defaultProps = {
    height: "520px"
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./components/core/signups/signup-with-text/signup-with-text-component.js + 1 modules
var signup_with_text_component = __webpack_require__(77385);
;// CONCATENATED MODULE: ./components/templates/article-template/article-item/article-item-component.scss.js



var StyledArticleItemComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "elwuxy30"
})("&.paragraph{padding:0 32px;}&.signup{margin:80px 0;display:flex;justify-content:center;}&.image,&.highlight{margin:64px 0;padding:0 32px;}.paragraph-title{margin-bottom:8px;font-size:1.75rem;font-weight:400;line-height:42px;}.paragraph-content{margin:0 0 24px 0;font-size:1rem;font-weight:300;line-height:28px;}.article-image{img{width:100%;}}.highlight-item{font-size:1.463rem;font-weight:300;line-height:38px;color:", colors/* default.brand-purple */.Z["brand-purple"], ";}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){&.paragraph,&.image,&.highlight{padding:0;}}");

// EXTERNAL MODULE: ./components/segments/competitors-comparison-table/competitors-comparison-table-component.js + 4 modules
var competitors_comparison_table_component = __webpack_require__(93030);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
;// CONCATENATED MODULE: ./components/templates/article-template/article-item/article-item-component.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}







var ArticleItemComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ArticleItemComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ArticleItemComponent);
    function ArticleItemComponent(props) {
        (0,_class_call_check/* default */.Z)(this, ArticleItemComponent);
        var _this;
        _this = _super.call(this, props);
        _this.renderSignup = _this.renderSignup.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderParagraph = _this.renderParagraph.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderImage = _this.renderImage.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderHighlight = _this.renderHighlight.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderComparisonTable = _this.renderComparisonTable.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ArticleItemComponent, [
        {
            key: "renderSignup",
            value: function renderSignup() {
                var title = this.props.title;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_with_text_component/* default */.Z, {
                    title: title
                });
            }
        },
        {
            key: "renderImage",
            value: function renderImage() {
                var _props = this.props, src = _props.src, alt = _props.alt;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "article-image",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                        src: src,
                        alt: alt
                    })
                });
            }
        },
        {
            key: "renderParagraph",
            value: function renderParagraph() {
                var _props = this.props, title = _props.title, isHighlight = _props.isHighlight, content = _props.content;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "paragraph-title",
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        }),
                        content && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "paragraph-content",
                            dangerouslySetInnerHTML: {
                                __html: content
                            }
                        })
                    ]
                });
            }
        },
        {
            key: "renderComparisonTable",
            value: function renderComparisonTable() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(competitors_comparison_table_component/* default */.Z, _object_spread({}, this.props));
            }
        },
        {
            key: "renderHighlight",
            value: function renderHighlight() {
                var content = this.props.content;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "highlight-item",
                    children: content
                });
            }
        },
        {
            key: "mapPartTypeToRenderer",
            value: function mapPartTypeToRenderer() {
                var partType = this.props.partType;
                switch(partType){
                    case "paragraph":
                        {
                            return this.renderParagraph;
                        }
                    case "signup":
                        {
                            return this.renderSignup;
                        }
                    case "image":
                        {
                            return this.renderImage;
                        }
                    case "highlight":
                        {
                            return this.renderHighlight;
                        }
                    case "comparisonTable":
                        {
                            return this.renderComparisonTable;
                        }
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, partType = _props.partType, content = _props.content, title = _props.title;
                var partRenderer = this.mapPartTypeToRenderer();
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledArticleItemComponent, {
                    className: "article-item-component ".concat(partType),
                    children: partRenderer()
                });
            }
        }
    ]);
    return ArticleItemComponent;
}(react.PureComponent);
/* harmony default export */ var article_item_component = ((0,generic_config_context/* withGenericConfig */.P)(ArticleItemComponent));

// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
;// CONCATENATED MODULE: ./components/templates/article-template/article-template-content/article-template-content-component.scss.js


var StyledArticleTemplateContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e7902d70"
})("display:flex;flex-direction:column;align-items:center;.article-items-list{margin:72px 0 64px 0;width:800px;}.content-footer-signup-wrapper{margin-bottom:24px;padding:0 24px;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.article-items-list{width:calc(100vw - 48px);}}.footer-disclaimer{font-size:0.8125rem;text-align:left;width:800px;padding:16px 32px;}");

;// CONCATENATED MODULE: ./components/templates/article-template/article-template-content/article-template-content-component.js




function article_template_content_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function article_template_content_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            article_template_content_component_define_property(target, key, source[key]);
        });
    }
    return target;
}







var ArticleTemplateContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ArticleTemplateContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ArticleTemplateContentComponent);
    function ArticleTemplateContentComponent() {
        (0,_class_call_check/* default */.Z)(this, ArticleTemplateContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ArticleTemplateContentComponent, [
        {
            key: "shouldRenderFooterSignupForm",
            value: function shouldRenderFooterSignupForm() {
                var footerSignup = this.props.footerSignup;
                return footerSignup && !footerSignup.preventSignup;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, headerStrip = _props.headerStrip, parts = _props.parts, footerSignup = _props.footerSignup, footerDisclaimer = _props.footerDisclaimer, abTests = _props.abTests;
                var shouldFocusOnSignup = true;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledArticleTemplateContentComponent, {
                    className: "article-template-content-component",
                    children: [
                        headerStrip && /*#__PURE__*/ (0,jsx_runtime.jsx)(AssetStripComponent, {
                            asset: headerStrip.asset,
                            title: headerStrip.title,
                            subtitle: headerStrip.subtitle,
                            preventSignup: headerStrip.preventSignup,
                            signupFocusOnLoad: shouldFocusOnSignup
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "article-items-list",
                            children: parts.map(function(part, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(article_item_component, article_template_content_component_object_spread({
                                    partType: part.type
                                }, part.props), index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "content-footer-signup-wrapper",
                            children: this.shouldRenderFooterSignupForm() && /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_with_text_component/* default */.Z, {
                                title: footerSignup.title,
                                subtitle: footerSignup.subtitle
                            })
                        }),
                        footerDisclaimer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "footer-disclaimer",
                            dangerouslySetInnerHTML: {
                                __html: footerDisclaimer
                            }
                        })
                    ]
                });
            }
        }
    ]);
    return ArticleTemplateContentComponent;
}(react.PureComponent);
/* harmony default export */ var article_template_content_component = ((0,ab_tests_context/* withAbTests */.k)(ArticleTemplateContentComponent));

// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-component.js + 81 modules
var base_header_component = __webpack_require__(33782);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.js + 1 modules
var long_footer_component = __webpack_require__(55408);
;// CONCATENATED MODULE: ./components/templates/article-template/article-template.js




function article_template_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function article_template_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            article_template_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






 //new for monday 2.0
 // //new for monday 2.0
var ArticleTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ArticleTemplate, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ArticleTemplate);
    function ArticleTemplate() {
        (0,_class_call_check/* default */.Z)(this, ArticleTemplate);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ArticleTemplate, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, headerUrl = _props.headerUrl, exitPopup = _props.exitPopup, loginTheme = _props.loginTheme, menuTheme = _props.menuTheme, stickyMode = _props.stickyMode, pageConfig = _props.pageConfig;
                var topbar = pageConfig.topbar, headerStrip = pageConfig.headerStrip, parts = pageConfig.parts, footerSignup = pageConfig.footerSignup, nameSignature = pageConfig.nameSignature, socialButtons = pageConfig.socialButtons, topBanner = pageConfig.topBanner, _footer = pageConfig.footer, footer = _footer === void 0 ? {} : _footer, exitPopupConfig = pageConfig.exitPopupConfig;
                var preventMenu = topbar && topbar.preventMenu;
                var preventFooter = footer && footer.preventFooter;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_template/* default */.Z, _object_spread_props(article_template_object_spread({}, this.props, pageConfig), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(base_header_component["default"], {
                            url: headerUrl,
                            loginTheme: loginTheme,
                            menuTheme: menuTheme,
                            showMenu: !preventMenu,
                            headerBackgroundColor: "white",
                            stickyMode: stickyMode,
                            allowSocialButtons: socialButtons && socialButtons.show,
                            socialButtonsColor: socialButtons && socialButtons.color,
                            socialButtonBlogStyle: socialButtons && socialButtons.blogStyle,
                            topBanner: topBanner
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                            id: element_ids/* MAIN_ID */.k,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(article_template_content_component, {
                                headerStrip: headerStrip,
                                parts: parts,
                                footerSignup: footerSignup,
                                footerDisclaimer: footer.disclaimer
                            })
                        }),
                        !preventFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_component["default"], {
                            nameSignature: nameSignature,
                            showTrustpilotReviews: pageConfig.showTrustpilotReviews
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(core_addons_component/* default */.Z, {
                            exitPopup: exitPopup,
                            exitPopupConfig: exitPopupConfig
                        })
                    ]
                }));
            }
        }
    ]);
    return ArticleTemplate;
}(react.PureComponent);

ArticleTemplate.defaultProps = {
    headerUrl: "https://monday.com/",
    title: "monday.com",
    description: "",
    exitPopup: true,
    menuTheme: "",
    loginTheme: ""
};


/***/ }),

/***/ 58072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CompetitorTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/top-bar-new/top-bar-component.js + 33 modules
var top_bar_component = __webpack_require__(21882);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/base-footer/base-footer-component.js + 1 modules
var base_footer_component = __webpack_require__(44574);
// EXTERNAL MODULE: ./components/addons/core-addons/core-addons-component.js + 8 modules
var core_addons_component = __webpack_require__(48124);
// EXTERNAL MODULE: ./components/templates/base-template.js + 50 modules
var base_template = __webpack_require__(44723);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/segments/header-with-two-columns-and-asset/header-with-two-columns-and-asset-component.scss.js


var componentStyles = new String(".header-with-two-columns-and-asset-component.jsx-cf7d2ee755054be1{min-height:-webkit-calc(100vh - 65px);min-height:-moz-calc(100vh - 65px);min-height:calc(100vh - 65px);display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;position:relative;.top-line.jsx-cf7d2ee755054be1{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;-webkit-box-flex:1;-webkit-flex:1 0 auto;-moz-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;.content-column.jsx-cf7d2ee755054be1{-webkit-box-flex:0;-webkit-flex:0 0 50%;-moz-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;.content-inner.jsx-cf7d2ee755054be1{width:80%;.content-title.jsx-cf7d2ee755054be1{font-size:3.2vw;margin-bottom:20px;font-weight:500}.content-subtitle.jsx-cf7d2ee755054be1{font-size:1.3vw;font-weight:400;line-height:1.3}.content-signup-form.jsx-cf7d2ee755054be1{.signup-form-wrapper{display:inline-block;text-align:left;.signup-form{.signup-input{padding:16px 35px}}}}.content-bullets.jsx-cf7d2ee755054be1{margin-top:40px;font-size:1.1vw;.bullet.jsx-cf7d2ee755054be1{margin-bottom:10px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:top;-webkit-align-items:top;-moz-box-align:top;-ms-flex-align:top;align-items:top;svg{margin-right:10px;width:16px;position:relative;top:0px}}}}}.asset-column.jsx-cf7d2ee755054be1{-webkit-box-flex:0;-webkit-flex:0 0 50%;-moz-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%;position:relative;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative;.asset-inner.jsx-cf7d2ee755054be1{width:80%;position:relative;.main-image{width:100%}}.hot-dog.jsx-cf7d2ee755054be1{position:absolute;width:100vw;height:40vw;background:orange;-webkit-border-radius:40vw;-moz-border-radius:40vw;border-radius:40vw;left:-10vh;bottom:55vh;-webkit-transform:rotate(-50deg);-moz-transform:rotate(-50deg);-ms-transform:rotate(-50deg);-o-transform:rotate(-50deg);transform:rotate(-50deg)}&.with-shadow.jsx-cf7d2ee755054be1{.asset-inner.jsx-cf7d2ee755054be1{-webkit-box-shadow:0px 2px 20px 1px rgba(177,177,177,.4);-moz-box-shadow:0px 2px 20px 1px rgba(177,177,177,.4);box-shadow:0px 2px 20px 1px rgba(177,177,177,.4)}}}.down-arrow-wrapper.jsx-cf7d2ee755054be1{position:absolute;bottom:20px;left:50%;-webkit-transform:translatex(-50%);-moz-transform:translatex(-50%);-ms-transform:translatex(-50%);-o-transform:translatex(-50%);transform:translatex(-50%);opacity:.5;svg{width:40px;height:40px}}}@media(max-width:".concat(vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){min-height:auto;padding:30px 20px;text-align:center;&.white-on-mobile.jsx-cf7d2ee755054be1{.content-column.jsx-cf7d2ee755054be1{.content-inner.jsx-cf7d2ee755054be1{color:white;.bullet.jsx-cf7d2ee755054be1{svg{fill:white}}}}}.top-line.jsx-cf7d2ee755054be1{-webkit-box-orient:vertical!important;-webkit-box-direction:normal!important;-webkit-flex-direction:column!important;-moz-box-orient:vertical!important;-moz-box-direction:normal!important;-ms-flex-direction:column!important;flex-direction:column!important;.content-column.jsx-cf7d2ee755054be1{position:relative;z-index:1;.content-inner.jsx-cf7d2ee755054be1{.content-title.jsx-cf7d2ee755054be1{font-size:1.575rem;margin-bottom:1.5vh;line-height:1.3}.content-subtitle.jsx-cf7d2ee755054be1{line-height:1.5;font-size:.875rem}.content-bullets.jsx-cf7d2ee755054be1{display:none}}}.asset-column.jsx-cf7d2ee755054be1{margin-top:20px;.hot-dog.jsx-cf7d2ee755054be1{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg);-webkit-border-radius:60vw;-moz-border-radius:60vw;border-radius:60vw;left:-10vh;bottom:10vh;right:-10vh;width:auto;height:200vh}}.down-arrow-wrapper.jsx-cf7d2ee755054be1{display:none}}}}"));
componentStyles.__hash = "cf7d2ee755054be1";

// EXTERNAL MODULE: ./static/svg/competitors-template/v.svg
var v = __webpack_require__(37531);
// EXTERNAL MODULE: ./static/svg/arrow-down.svg
var arrow_down = __webpack_require__(83900);
;// CONCATENATED MODULE: ./components/segments/header-with-two-columns-and-asset/header-with-two-columns-and-asset-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}











var DEFAULT_HOTDOG_COLOR = "brand-purple";
var HeaderWithTwoColumnsAndAssetComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(HeaderWithTwoColumnsAndAssetComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(HeaderWithTwoColumnsAndAssetComponent);
    function HeaderWithTwoColumnsAndAssetComponent() {
        (0,_class_call_check/* default */.Z)(this, HeaderWithTwoColumnsAndAssetComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(HeaderWithTwoColumnsAndAssetComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, signupForm = _props.signupForm, hotDog = _props.hotDog, title = _props.title, subtitle = _props.subtitle, asset = _props.asset, textColor = _props.textColor, imageWidth = _props.imageWidth, bullets = _props.bullets;
                var shadow = asset.shadow, image = asset.image;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(componentStyles.__hash) + " " + "header-with-two-columns-and-asset-component ".concat([
                        "brand-yellow",
                        "brand-light-blue"
                    ].indexOf(hotDog.color) > -1 ? "" : "white-on-mobile"),
                    children: [
                        hotDog && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                backgroundColor: colors/* default */.Z[hotDog.color]
                            },
                            className: "jsx-".concat(componentStyles.__hash) + " " + "hot-dog"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(componentStyles.__hash) + " " + "top-line",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-".concat(componentStyles.__hash) + " " + "content-column",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-".concat(componentStyles.__hash) + " " + "content-inner",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                dangerouslySetInnerHTML: {
                                                    __html: title
                                                },
                                                className: "jsx-".concat(componentStyles.__hash) + " " + "content-title"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                dangerouslySetInnerHTML: {
                                                    __html: subtitle
                                                },
                                                className: "jsx-".concat(componentStyles.__hash) + " " + "content-subtitle"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "jsx-".concat(componentStyles.__hash) + " " + "content-signup-form",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                                                    className: "align-left",
                                                    focusOnLoad: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "jsx-".concat(componentStyles.__hash) + " " + "content-bullets",
                                                children: bullets.map(function(bullet, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "jsx-".concat(componentStyles.__hash) + " " + "bullet",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "jsx-".concat(componentStyles.__hash),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v/* default */.Z, {})
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "jsx-".concat(componentStyles.__hash),
                                                                children: bullet
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "jsx-".concat(componentStyles.__hash) + " " + (classnames_default()("asset-column", {
                                        "with-shadow": shadow
                                    }) || ""),
                                    children: [
                                        hotDog && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                background: colors/* default */.Z[hotDog.color] || colors/* default */.Z[DEFAULT_HOTDOG_COLOR]
                                            },
                                            className: "jsx-".concat(componentStyles.__hash) + " " + "hot-dog"
                                        }),
                                        image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                width: "".concat(image.widthPercentage, "%")
                                            },
                                            className: "jsx-".concat(componentStyles.__hash) + " " + "asset-inner",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, _object_spread({
                                                className: "main-image"
                                            }, image))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-".concat(componentStyles.__hash) + " " + "down-arrow-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_down/* default */.Z, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: componentStyles.__hash,
                            children: componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return HeaderWithTwoColumnsAndAssetComponent;
}(react.PureComponent);

HeaderWithTwoColumnsAndAssetComponent.defaultProps = {
    backgroundColor: "brand-purple",
    hotDog: {},
    asset: {},
    title: "",
    subtitle: "",
    signupForm: true,
    textColor: "",
    imageWidth: "50%",
    bullets: []
};

// EXTERNAL MODULE: ./components/segments/competitors-comparison-table/competitors-comparison-table-component.js + 4 modules
var competitors_comparison_table_component = __webpack_require__(93030);
// EXTERNAL MODULE: ./components/core/signups/signup-with-text/signup-with-text-component.js + 1 modules
var signup_with_text_component = __webpack_require__(77385);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/templates/competitor-template/competitor-template.scss.js

var StyledCompetitorSignupForm = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eekrt5t0"
})("margin:32px 20px 100px 20px;display:flex;justify-content:center;");
var StyledFooterDisclaimer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eekrt5t1"
})("font-size:0.8125rem;width:100%;padding:16px 50px;");

;// CONCATENATED MODULE: ./components/templates/competitor-template/competitor-template.js




function competitor_template_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function competitor_template_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            competitor_template_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}











var CompetitorTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CompetitorTemplate, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CompetitorTemplate);
    function CompetitorTemplate() {
        (0,_class_call_check/* default */.Z)(this, CompetitorTemplate);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CompetitorTemplate, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, headerUrl = _props.headerUrl, exitPopup = _props.exitPopup, loginTheme = _props.loginTheme, menuTheme = _props.menuTheme, stickyMode = _props.stickyMode, pageConfig = _props.pageConfig;
                var topSection = pageConfig.topSection, comparisonTable = pageConfig.comparisonTable, footerSignup = pageConfig.footerSignup, _footer = pageConfig.footer, footer = _footer === void 0 ? {} : _footer, socialButtons = pageConfig.socialButtons, topBanner = pageConfig.topBanner, exitPopupConfig = pageConfig.exitPopupConfig;
                var preventFooter = footer && footer.preventFooter;
                var hotDog = topSection.hotDog;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_template/* default */.Z, _object_spread_props(competitor_template_object_spread({}, this.props, pageConfig), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "competitor-top-bar",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(top_bar_component/* default */.Z, {
                                url: headerUrl,
                                loginTheme: loginTheme,
                                menuTheme: menuTheme,
                                showMenu: false,
                                stickyMode: stickyMode,
                                mobileLogoTheme: hotDog && hotDog.color == "brand-yellow" ? "black-theme" : "light-theme",
                                allowSocialButtons: socialButtons && socialButtons.show,
                                socialButtonsColor: socialButtons && socialButtons.color,
                                socialButtonBlogStyle: socialButtons && socialButtons.blogStyle,
                                topBanner: topBanner,
                                maxWidth: "100%",
                                headerBackgroundColor: "white"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWithTwoColumnsAndAssetComponent, competitor_template_object_spread({}, topSection)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(competitors_comparison_table_component/* default */.Z, competitor_template_object_spread({}, comparisonTable)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCompetitorSignupForm, {
                                    className: "competitors-signup-form",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_with_text_component/* default */.Z, competitor_template_object_spread({}, footerSignup))
                                })
                            ]
                        }),
                        footer.disclaimer && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooterDisclaimer, {
                            className: "footer-disclaimer",
                            dangerouslySetInnerHTML: {
                                __html: footer.disclaimer
                            }
                        }),
                        !preventFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(base_footer_component["default"], {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(core_addons_component/* default */.Z, {
                            exitPopup: exitPopup,
                            exitPopupConfig: exitPopupConfig
                        })
                    ]
                }));
            }
        }
    ]);
    return CompetitorTemplate;
}(react.PureComponent);

CompetitorTemplate.defaultProps = {
    headerUrl: "https://monday.com/",
    title: "monday.com",
    description: "",
    exitPopup: true,
    menuTheme: "",
    loginTheme: ""
};


/***/ }),

/***/ 9644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DirectoryImagesTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/templates/base-template.js + 50 modules
var base_template = __webpack_require__(44723);
// EXTERNAL MODULE: ./constants/element-ids.js
var element_ids = __webpack_require__(53219);
// EXTERNAL MODULE: ./components/addons/core-addons/core-addons-component.js + 8 modules
var core_addons_component = __webpack_require__(48124);
// EXTERNAL MODULE: ./components/core/directory/index.js + 21 modules
var directory = __webpack_require__(76291);
// EXTERNAL MODULE: ./constants/thumbnails-types.js
var thumbnails_types = __webpack_require__(50432);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/templates/directory-images-template/directory-images-template.scss.js


var StyledDirectoryTemplateComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ed2kd5h0"
})(".directory-component-wrapper{background-color:#f5f5f5;padding-top:80px;}nav.navbar{background-color:", colors/* default.white */.Z.white, " !important;}");

// EXTERNAL MODULE: ./services/directories-service.js
var directories_service = __webpack_require__(37221);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-component.js + 81 modules
var base_header_component = __webpack_require__(33782);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.js + 1 modules
var long_footer_component = __webpack_require__(55408);
;// CONCATENATED MODULE: ./components/templates/directory-images-template/directory-images-template.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









 //new for monday 2.0
 // //new for monday 2.0
var DirectoryImagesTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(DirectoryImagesTemplate, PureComponent);
    var _super = (0,_create_super/* default */.Z)(DirectoryImagesTemplate);
    function DirectoryImagesTemplate(props) {
        (0,_class_call_check/* default */.Z)(this, DirectoryImagesTemplate);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            searchValue: null
        };
        _this.onSearchChange = _this.onSearchChange.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.filterValidator = _this.filterValidator.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(DirectoryImagesTemplate, [
        {
            key: "onSearchChange",
            value: function onSearchChange(value) {
                this.setState({
                    searchValue: value
                });
            }
        },
        {
            key: "filterValidator",
            value: function filterValidator(item) {
                var searchValue = this.state.searchValue;
                return (0,directories_service/* itemFilterValidator */.P)(item, searchValue);
            }
        },
        {
            key: "render",
            value: function render() {
                var exitPopup = this.props.exitPopup;
                var _pageConfig = this.props.pageConfig, header = _pageConfig.header, listData = _pageConfig.listData, socialButtons = _pageConfig.socialButtons, topBanner = _pageConfig.topBanner, exitPopupConfig = _pageConfig.exitPopupConfig;
                var searchValue = this.state.searchValue;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(base_template/* default */.Z, _object_spread_props(_object_spread({}, this.props, this.props.pageConfig), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDirectoryTemplateComponent, {
                        className: "directory-template-component",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_header_component["default"], {
                                allowSocialButtons: socialButtons && socialButtons.show,
                                socialButtonsColor: socialButtons && socialButtons.color,
                                socialButtonBlogStyle: socialButtons && socialButtons.blogStyle,
                                topBanner: topBanner,
                                maxWidth: "100%",
                                showMenu: true,
                                headerBackgroundColor: "white"
                            }),
                            header && /*#__PURE__*/ (0,jsx_runtime.jsx)(directory/* DirectoryHeaderComponent */.bS, _object_spread_props(_object_spread({}, header), {
                                searchValue: searchValue,
                                onSearchChange: this.onSearchChange
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                                className: "directory-component-wrapper",
                                id: element_ids/* MAIN_ID */.k,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(directory/* DirectoryComponent */.wm, {
                                    filterTerm: searchValue,
                                    tuhmbnailsListData: listData,
                                    thumbnailType: thumbnails_types/* THUMBNAILS_TYPES.BACKGROUND_IMAGE */.H.BACKGROUND_IMAGE,
                                    filterValidator: this.filterValidator
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_component["default"], {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(core_addons_component/* default */.Z, {
                                exitPopup: exitPopup,
                                exitPopupConfig: exitPopupConfig
                            })
                        ]
                    })
                }));
            }
        }
    ]);
    return DirectoryImagesTemplate;
}(react.PureComponent);

DirectoryImagesTemplate.defaultProps = {
    exitPopup: true,
    pageConfig: {
        header: {
            color: "brand-red",
            text: "sdkhjdsjhkds",
            height: "360px",
            img: "/static/img/strips/strip-computer-coffee.png"
        },
        listData: [],
        footerSignup: {
            title: "Start using monday.com today",
            subtitle: "Try it now for free / No credit card needed"
        }
    }
};


/***/ }),

/***/ 13838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FixedLongLpTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/top-bar-new/top-bar-component.js + 33 modules
var top_bar_component = __webpack_require__(21882);
// EXTERNAL MODULE: ./components/addons/core-addons/core-addons-component.js + 8 modules
var core_addons_component = __webpack_require__(48124);
// EXTERNAL MODULE: ./components/segments/basic-segments.js + 7 modules
var basic_segments = __webpack_require__(1241);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./contexts/preview-base-segment-context.js + 4 modules
var preview_base_segment_context = __webpack_require__(70349);
// EXTERNAL MODULE: ./constants/element-ids.js
var element_ids = __webpack_require__(53219);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/templates/fixed-long-lp-template/fixed-long-lp-template.scss.js


var StyledFixedLongLpTemplate = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e3e9hzm0"
})("box-sizing:content-box;.segment-content-container{&:not(.full-width){max-width:", vp_sizes/* MAX_DESKTOP_CONTENT_WIDTH */.O$, "px;}margin:auto;}");

// EXTERNAL MODULE: ./components/templates/base-template.js + 50 modules
var base_template = __webpack_require__(44723);
;// CONCATENATED MODULE: ./components/templates/fixed-long-lp-template/fixed-long-lp-template.js






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}











var FixedLongLpTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FixedLongLpTemplate, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FixedLongLpTemplate);
    function FixedLongLpTemplate() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, FixedLongLpTemplate);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getSegmentStyle", function(segment) {
            var _props = segment.props, paddingTop = _props.paddingTop, paddingBottom = _props.paddingBottom, backgroundColor = _props.backgroundColor, textColor = _props.textColor;
            var actualBackgroundColor = colors/* default */.Z[backgroundColor];
            var color = colors/* default */.Z[textColor];
            var segmentStyleOverride = segment.baseSegmentStyleOverride || {};
            return _object_spread({
                paddingTop: paddingTop,
                paddingBottom: paddingBottom,
                color: color,
                backgroundColor: actualBackgroundColor
            }, segmentStyleOverride);
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderSegment", function(segment) {
            var SegmentComponent = basic_segments/* default */.Z[segment.type];
            if (!SegmentComponent) return null;
            var isFullWidth = segment.props.isFullWidth;
            var style = _this.getSegmentStyle(segment);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFixedLongLpTemplate, {
                className: "base-layout-segment-component",
                style: style,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("segment-content-container", {
                        "full-width": isFullWidth
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "segment-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SegmentComponent, _object_spread({}, segment.props))
                    })
                })
            });
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderBasicSegments", function() {
            var _props = _this.props, pageConfig = _props.pageConfig, isPreview = _props.isPreview;
            var segments = pageConfig.segments;
            return segments.map(function(segment, index) {
                var Segment = function() {
                    return _this.renderSegment(segment);
                };
                var Component = isPreview ? (0,preview_base_segment_context/* withPreviewBaseSegment */.I)(Segment) : Segment;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                        index: index
                    })
                }, index);
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(FixedLongLpTemplate, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, headerUrl = _props.headerUrl, exitPopup = _props.exitPopup, pageConfig = _props.pageConfig;
                var topbar = pageConfig.topbar, topBanner = pageConfig.topBanner, exitPopupConfig = pageConfig.exitPopupConfig;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_template/* default */.Z, _object_spread_props(_object_spread({}, this.props, pageConfig), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(top_bar_component/* default */.Z, _object_spread_props(_object_spread({}, topbar), {
                            url: headerUrl,
                            headerBackgroundColor: "white",
                            topBanner: topBanner,
                            maxWidth: "100%",
                            showMenu: false
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                            id: element_ids/* MAIN_ID */.k,
                            children: [
                                " ",
                                this.renderBasicSegments()
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(core_addons_component/* default */.Z, {
                            exitPopup: exitPopup,
                            exitPopupConfig: exitPopupConfig
                        })
                    ]
                }));
            }
        }
    ]);
    return FixedLongLpTemplate;
}(react.PureComponent);

FixedLongLpTemplate.defaultProps = {
    headerUrl: "https://monday.com/",
    title: "monday.com",
    description: "",
    exitPopup: true,
    topbar: {}
};


/***/ }),

/***/ 38496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HomepageTemplate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_top_bar_new_top_bar_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21882);
/* harmony import */ var _components_addons_core_addons_core_addons_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48124);
/* harmony import */ var constants_element_ids__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(53219);
/* harmony import */ var segments_desktop_header_layouts_base_header_base_header_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33782);
/* harmony import */ var segments_desktop_footer_layouts_long_footer_long_footer_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55408);
/* harmony import */ var _base_template__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44723);





function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





 //new for monday 2.0
 // //new for monday 2.0

var HomepageTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(HomepageTemplate, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(HomepageTemplate);
    function HomepageTemplate() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(this, HomepageTemplate);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(HomepageTemplate, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, children = _props.children, headerUrl = _props.headerUrl, exitPopup = _props.exitPopup, loginTheme = _props.loginTheme, menuTheme = _props.menuTheme, showMenu = _props.showMenu, headerBackgroundColor = _props.headerBackgroundColor, stickyMode = _props.stickyMode, allowSocialButtons = _props.allowSocialButtons, socialButtonsColor = _props.socialButtonsColor, topBarClassName = _props.topBarClassName, topBanner = _props.topBanner, maxWidth = _props.maxWidth, socialButtonBlogStyle = _props.socialButtonBlogStyle, desktopHeaderLinks = _props.desktopHeaderLinks, sectionRenderer = _props.sectionRenderer, mobileHeaderLinks = _props.mobileHeaderLinks, useV1TopBar = _props.useV1TopBar;
                var HeaderComponent = useV1TopBar ? _components_core_top_bar_new_top_bar_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z : segments_desktop_header_layouts_base_header_base_header_component__WEBPACK_IMPORTED_MODULE_4__["default"];
                var _obj;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_base_template__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, _object_spread_props(_object_spread({}, this.props), {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HeaderComponent, (_obj = {
                            url: headerUrl,
                            loginTheme: loginTheme,
                            menuTheme: menuTheme,
                            showMenu: showMenu,
                            headerBackgroundColor: headerBackgroundColor,
                            stickyMode: stickyMode,
                            allowSocialButtons: allowSocialButtons,
                            socialButtonsColor: socialButtonsColor,
                            socialButtonBlogStyle: socialButtonBlogStyle,
                            className: topBarClassName,
                            topBanner: topBanner,
                            maxWidth: maxWidth
                        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, "headerBackgroundColor", headerBackgroundColor), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, "desktopHeaderLinks", desktopHeaderLinks), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, "sectionRenderer", sectionRenderer), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, "mobileHeaderLinks", mobileHeaderLinks), _obj)),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                            id: constants_element_ids__WEBPACK_IMPORTED_MODULE_12__/* .MAIN_ID */ .k,
                            children: children
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(segments_desktop_footer_layouts_long_footer_long_footer_component__WEBPACK_IMPORTED_MODULE_5__["default"], {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_addons_core_addons_core_addons_component__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            exitPopup: exitPopup
                        })
                    ]
                }));
            }
        }
    ]);
    return HomepageTemplate;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

HomepageTemplate.defaultProps = {
    headerUrl: "https://auth.monday.com/",
    title: "monday.com",
    description: "",
    exitPopup: true,
    menuTheme: "",
    showMenu: true,
    loginTheme: "",
    allowSocialButtons: false,
    headerBackgroundColor: "transparent",
    maxWidth: "100%",
    useV1TopBar: false
};


/***/ }),

/***/ 64172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ templates; }
});

// EXTERNAL MODULE: ./components/templates/homepage-template.js
var homepage_template = __webpack_require__(38496);
// EXTERNAL MODULE: ./components/templates/long-template/long-template.js + 3 modules
var long_template = __webpack_require__(25520);
// EXTERNAL MODULE: ./components/templates/segments-template/segments-template.js + 3 modules
var segments_template = __webpack_require__(8335);
// EXTERNAL MODULE: ./components/templates/fixed-long-lp-template/fixed-long-lp-template.js + 1 modules
var fixed_long_lp_template = __webpack_require__(13838);
// EXTERNAL MODULE: ./components/templates/article-template/article-template.js + 6 modules
var article_template = __webpack_require__(60500);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./components/core/directory/index.js + 21 modules
var directory = __webpack_require__(76291);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/templates/directory-template/directory-header/directory-header-component.scss.js



var StyledDirectoryHeaderComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1glm6lz0"
})("position:relative;img{height:100%;}.header-text{position:absolute;left:0;right:0;top:0;bottom:0;display:flex;justify-content:center;align-items:center;h1{font-size:5vw;color:", colors/* default.white */.Z.white, ";}}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){img{height:70%;}.header-text{h1{font-size:4.5rem;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){img{display:none;}.header-text{h1{font-size:3.375rem;}}}");

;// CONCATENATED MODULE: ./components/templates/directory-template/directory-header/directory-header-component.js








var DirectoryHeaderComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(DirectoryHeaderComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(DirectoryHeaderComponent);
    function DirectoryHeaderComponent() {
        (0,_class_call_check/* default */.Z)(this, DirectoryHeaderComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(DirectoryHeaderComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, height = _props.height, color = _props.color, text = _props.text, img = _props.img;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDirectoryHeaderComponent, {
                    className: "directory-header-component",
                    style: {
                        height: height,
                        backgroundColor: colors/* default */.Z[color]
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: img
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "header-text",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: text
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return DirectoryHeaderComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/templates/directory-template/directory-template.scss.js

var StyledDirectoryTemplate = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e8dzi9d0"
})(".directory-component-wrapper{background-color:#f5f5f5;padding-top:64px;}");

// EXTERNAL MODULE: ./constants/thumbnails-types.js
var thumbnails_types = __webpack_require__(50432);
;// CONCATENATED MODULE: ./components/templates/directory-template/directory-template.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var DirectoryTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(DirectoryTemplate, PureComponent);
    var _super = (0,_create_super/* default */.Z)(DirectoryTemplate);
    function DirectoryTemplate() {
        (0,_class_call_check/* default */.Z)(this, DirectoryTemplate);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(DirectoryTemplate, [
        {
            key: "render",
            value: function render() {
                var _pageConfig = this.props.pageConfig, title = _pageConfig.title, description = _pageConfig.description, pagePath = _pageConfig.pagePath, header = _pageConfig.header, listData = _pageConfig.listData, footerSignup = _pageConfig.footerSignup, socialButtons = _pageConfig.socialButtons;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_template/* default */.Z, _object_spread_props(_object_spread({}, this.props, this.props.pageConfig), {
                    allowSocialButtons: socialButtons && socialButtons.show,
                    socialButtonsColor: socialButtons && socialButtons.color,
                    socialButtonBlogStyle: socialButtons && socialButtons.blogStyle,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDirectoryTemplate, {
                        className: "directory-template-component",
                        children: [
                            header && /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectoryHeaderComponent, _object_spread({}, header)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "directory-component-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(directory/* DirectoryComponent */.wm, {
                                    tuhmbnailsListData: listData,
                                    thumbnailType: thumbnails_types/* THUMBNAILS_TYPES.BACKGROUND_COLOR */.H.BACKGROUND_COLOR
                                })
                            })
                        ]
                    })
                }));
            }
        }
    ]);
    return DirectoryTemplate;
}(react.PureComponent);

DirectoryTemplate.defaultProps = {
    pageConfig: {
        header: {
            color: "brand-red",
            text: "sdkhjdsjhkds",
            height: "360px",
            img: "/static/img/strips/strip-computer-coffee.png"
        },
        listData: [],
        footerSignup: {
            title: "Start using monday.com today",
            subtitle: "Try it now for free / No credit card needed"
        }
    }
};

// EXTERNAL MODULE: ./components/templates/directory-images-template/directory-images-template.js + 1 modules
var directory_images_template = __webpack_require__(9644);
// EXTERNAL MODULE: ./components/templates/multiple-directory-images-template/multiple-directory-images-template.js + 1 modules
var multiple_directory_images_template = __webpack_require__(49979);
// EXTERNAL MODULE: ./components/templates/one-pager-asset-template/one-pager-asset-template.js + 8 modules
var one_pager_asset_template = __webpack_require__(87355);
// EXTERNAL MODULE: ./components/templates/one-pager-with-image-template/one-pager-with-image-template.js
var one_pager_with_image_template = __webpack_require__(8264);
// EXTERNAL MODULE: ./components/templates/one-pager-with-image-template/mobile-only/mobile-one-pager-with-image-template.js + 2 modules
var mobile_one_pager_with_image_template = __webpack_require__(36278);
// EXTERNAL MODULE: ./components/templates/one-pager-with-video-template/one-pager-with-video-template.js + 6 modules
var one_pager_with_video_template = __webpack_require__(55114);
// EXTERNAL MODULE: ./components/templates/competitor-template/competitor-template.js + 3 modules
var competitor_template = __webpack_require__(58072);
// EXTERNAL MODULE: ./components/templates/dynamic-template/dynamic-template.js + 5 modules
var dynamic_template = __webpack_require__(48665);
;// CONCATENATED MODULE: ./components/templates/index.js















/* harmony default export */ var templates = ({
    HomepageTemplate: homepage_template/* default */.Z,
    LongTemplate: long_template/* default */.Z,
    SegmentsTemplate: segments_template/* default */.Z,
    FixedLongLpTemplate: fixed_long_lp_template/* default */.Z,
    ArticleTemplate: article_template/* default */.Z,
    DirectoryTemplate: DirectoryTemplate,
    DirectoryImagesTemplate: directory_images_template/* default */.Z,
    MultipleDirectoryImagesTemplate: multiple_directory_images_template/* default */.Z,
    OnePagerAssetTemplate: one_pager_asset_template/* default */.Z,
    OnePagerWithImageTemplate: one_pager_with_image_template/* default */.Z,
    MobileOnePagerWithImageTemplate: mobile_one_pager_with_image_template/* default */.Z,
    CompetitorTemplate: competitor_template/* default */.Z,
    OnePagerWithVideoTemplate: one_pager_with_video_template/* default */.Z,
    DynamicTemplate: dynamic_template/* default */.Z,
    MobileDynamicTemplate: dynamic_template/* default */.Z,
    DevelopersCenterTemplate: dynamic_template/* default */.Z,
    WelcomeNewJoinersTemplate: dynamic_template/* default */.Z,
    RemoteWorkTemplate: dynamic_template/* default */.Z
});


/***/ }),

/***/ 25520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LongTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/top-bar-new/top-bar-component.js + 33 modules
var top_bar_component = __webpack_require__(21882);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/base-footer/base-footer-component.js + 1 modules
var base_footer_component = __webpack_require__(44574);
// EXTERNAL MODULE: ./constants/element-ids.js
var element_ids = __webpack_require__(53219);
// EXTERNAL MODULE: ./components/addons/core-addons/core-addons-component.js + 8 modules
var core_addons_component = __webpack_require__(48124);
// EXTERNAL MODULE: ./components/templates/base-template.js + 50 modules
var base_template = __webpack_require__(44723);
// EXTERNAL MODULE: ./components/segments/index.js + 96 modules
var segments = __webpack_require__(91237);
;// CONCATENATED MODULE: ./components/segments/base-segment/base-segment-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var BaseSegmentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BaseSegmentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BaseSegmentComponent);
    function BaseSegmentComponent() {
        (0,_class_call_check/* default */.Z)(this, BaseSegmentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BaseSegmentComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, segment = _props.segment, isUserLoggedIn = _props.isUserLoggedIn, extraProps = _props.extraProps;
                var SegmentComponent = segments/* default */.Z[segment.type];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SegmentComponent, _object_spread_props(_object_spread({}, extraProps, segment.props), {
                    isUserLoggedIn: isUserLoggedIn
                }));
            }
        }
    ]);
    return BaseSegmentComponent;
}(react.PureComponent);

BaseSegmentComponent.defaultProps = {
    extraProps: {}
};

// EXTERNAL MODULE: ./contexts/preview-base-segment-context.js + 4 modules
var preview_base_segment_context = __webpack_require__(70349);
;// CONCATENATED MODULE: ./components/segments/segments-list/segments-list-component.js








var SegmentsListComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SegmentsListComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SegmentsListComponent);
    function SegmentsListComponent() {
        (0,_class_call_check/* default */.Z)(this, SegmentsListComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SegmentsListComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, segments = _props.segments, isUserLoggedIn = _props.isUserLoggedIn, extraProps = _props.extraProps, isPreview = _props.isPreview;
                var Component = isPreview ? (0,preview_base_segment_context/* withPreviewBaseSegment */.I)(BaseSegmentComponent) : BaseSegmentComponent;
                return segments.map(function(s, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                        extraProps: extraProps,
                        segment: s,
                        isUserLoggedIn: isUserLoggedIn,
                        index: index
                    }, "".concat(s.type, "_").concat(index));
                });
            }
        }
    ]);
    return SegmentsListComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./constants/logo-themes.js
var LOGO_THEME_BLACK_COLOR = "black-color-theme";
var LOGO_THEME_BLACK = "black-theme";
var LOGO_THEME_LIGHT_COLOR = "light-color-theme";
var LOGO_THEME_LIGHT = "light-theme";

;// CONCATENATED MODULE: ./components/templates/long-template/long-template.js




function long_template_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function long_template_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            long_template_define_property(target, key, source[key]);
        });
    }
    return target;
}
function long_template_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function long_template_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        long_template_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var LongTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LongTemplate, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LongTemplate);
    function LongTemplate() {
        (0,_class_call_check/* default */.Z)(this, LongTemplate);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(LongTemplate, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, headerUrl = _props.headerUrl, exitPopup = _props.exitPopup, stickyMode = _props.stickyMode, pageConfig = _props.pageConfig, isPreview = _props.isPreview;
                var segments = pageConfig.segments, topbar = pageConfig.topbar, footer = pageConfig.footer, socialButtons = pageConfig.socialButtons, topBanner = pageConfig.topBanner, exitPopupConfig = pageConfig.exitPopupConfig;
                var preventMenu = topbar && topbar.preventMenu;
                var preventFooter = footer && footer.preventFooter;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_template/* default */.Z, long_template_object_spread_props(long_template_object_spread({}, this.props, pageConfig), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(top_bar_component/* default */.Z, {
                            url: headerUrl,
                            loginTheme: pageConfig.loginTheme,
                            menuTheme: pageConfig.menuTheme,
                            logoTheme: LOGO_THEME_LIGHT_COLOR,
                            showMenu: !preventMenu,
                            stickyMode: stickyMode,
                            allowSocialButtons: socialButtons && socialButtons.show,
                            socialButtonsColor: socialButtons && socialButtons.color,
                            socialButtonBlogStyle: socialButtons && socialButtons.blogStyle,
                            topBanner: topBanner,
                            maxWidth: "100%",
                            headerBackgroundColor: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                            id: element_ids/* MAIN_ID */.k,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SegmentsListComponent, {
                                segments: segments,
                                isPreview: isPreview
                            })
                        }),
                        !preventFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(base_footer_component["default"], {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(core_addons_component/* default */.Z, {
                            exitPopup: exitPopup,
                            exitPopupConfig: exitPopupConfig
                        })
                    ]
                }));
            }
        }
    ]);
    return LongTemplate;
}(react.PureComponent);

LongTemplate.defaultProps = {
    headerUrl: "https://monday.com/",
    title: "monday.com",
    description: "",
    exitPopup: true,
    menuTheme: "",
    loginTheme: ""
};


/***/ }),

/***/ 49979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MultipleDirectoryImagesTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./components/templates/base-template.js + 50 modules
var base_template = __webpack_require__(44723);
// EXTERNAL MODULE: ./components/addons/core-addons/core-addons-component.js + 8 modules
var core_addons_component = __webpack_require__(48124);
// EXTERNAL MODULE: ./components/core/directory/index.js + 21 modules
var core_directory = __webpack_require__(76291);
// EXTERNAL MODULE: ./constants/thumbnails-types.js
var thumbnails_types = __webpack_require__(50432);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/templates/multiple-directory-images-template/multiple-directory-images-template.scss.js



var StyledMultipleDirectoryImagesTemplate = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e64pb930"
})(".directories-list-wrapper{background-color:#f5f5f5;padding-top:80px;}nav.navbar{background-color:", colors/* default.white */.Z.white, " !important;}.directory-list-item-title{max-width:1320px;width:calc(100vw - 32px);margin:0 auto 16px auto;padding:16px 0;border-width:0 0 1px 0;border-style:solid;font-size:2vw;font-weight:400;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.directory-list-item-title{max-width:calc(100% - 48px);font-size:1.375rem;}}");
var StyledEmptyResult = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e64pb931"
})("padding-bottom:80px;");

// EXTERNAL MODULE: ./services/directories-service.js
var directories_service = __webpack_require__(37221);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-component.js + 81 modules
var base_header_component = __webpack_require__(33782);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.js + 1 modules
var long_footer_component = __webpack_require__(55408);
;// CONCATENATED MODULE: ./components/templates/multiple-directory-images-template/multiple-directory-images-template.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var ENABLE_DIRECTORY_ITEM_SIGNUP_FORM = {
    show: true,
    title: "Start using monday.com today",
    subtitle: "Try it now for free / No credit card needed"
};
 //new for monday 2.0
 // //new for monday 2.0
var DISABLE_DIRECTORY_ITEM_SIGNUP_FORM = {
    show: false
};
var MultipleDirectoryImagesTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MultipleDirectoryImagesTemplate, PureComponent);
    var _super = (0,_create_super/* default */.Z)(MultipleDirectoryImagesTemplate);
    function MultipleDirectoryImagesTemplate(props) {
        (0,_class_call_check/* default */.Z)(this, MultipleDirectoryImagesTemplate);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            searchValue: null
        };
        _this.onSearchChange = _this.onSearchChange.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderDirectory = _this.renderDirectory.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.filterValidator = _this.filterValidator.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(MultipleDirectoryImagesTemplate, [
        {
            key: "onSearchChange",
            value: function onSearchChange(value) {
                this.setState({
                    searchValue: value
                });
            }
        },
        {
            key: "hasFilter",
            value: function hasFilter() {
                var searchValue = this.state.searchValue;
                return searchValue && searchValue != "";
            }
        },
        {
            key: "filterValidator",
            value: function filterValidator(item) {
                var searchValue = this.state.searchValue;
                return (0,directories_service/* itemFilterValidator */.P)(item, searchValue);
            }
        },
        {
            key: "shouldShowDirectory",
            value: function shouldShowDirectory(directory) {
                var searchValue = this.state.searchValue;
                var listData = directory.props.listData;
                var filteredItems = listData.filter(this.filterValidator);
                return filteredItems.length > 0;
            }
        },
        {
            key: "getFilteredDirectories",
            value: function getFilteredDirectories() {
                var _this = this;
                var directories = this.props.pageConfig.directories;
                if (!this.hasFilter()) {
                    return directories;
                }
                return directories.filter(function(directory) {
                    return _this.shouldShowDirectory(directory);
                });
            }
        },
        {
            key: "renderDirectory",
            value: function renderDirectory(directory, index) {
                var _props = directory.props, title = _props.title, titleColor = _props.titleColor, listData = _props.listData;
                var searchValue = this.state.searchValue;
                var directories = this.props.pageConfig.directories;
                var isLastDirectory = index + 1 === directories.length;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "directory-list-item",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "directory-list-item-title",
                            style: {
                                color: colors/* default */.Z[titleColor],
                                borderColor: colors/* default */.Z[titleColor]
                            },
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "directory-component-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(core_directory/* DirectoryComponent */.wm, {
                                filterTerm: searchValue,
                                tuhmbnailsListData: listData,
                                thumbnailType: thumbnails_types/* THUMBNAILS_TYPES.BACKGROUND_IMAGE */.H.BACKGROUND_IMAGE,
                                signupForm: isLastDirectory ? ENABLE_DIRECTORY_ITEM_SIGNUP_FORM : DISABLE_DIRECTORY_ITEM_SIGNUP_FORM,
                                filterValidator: this.filterValidator
                            })
                        })
                    ]
                }, index);
            }
        },
        {
            key: "renderEmptyState",
            value: function renderEmptyState() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledEmptyResult, {
                    className: "empty-results-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(core_directory/* DirectoryEmptyStateComponent */.it, {})
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var exitPopup = this.props.exitPopup;
                var _pageConfig = this.props.pageConfig, title = _pageConfig.title, description = _pageConfig.description, pagePath = _pageConfig.pagePath, header = _pageConfig.header, socialButtons = _pageConfig.socialButtons, topBanner = _pageConfig.topBanner, exitPopupConfig = _pageConfig.exitPopupConfig;
                var searchValue = this.state.searchValue;
                var filteredDirectories = this.getFilteredDirectories();
                var shouldRenderEmptyState = filteredDirectories.length === 0;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(base_template/* default */.Z, _object_spread_props(_object_spread({}, this.props), {
                    title: title,
                    description: description,
                    pagePath: pagePath,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMultipleDirectoryImagesTemplate, {
                        className: "multiple-directory-template-component",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_header_component["default"], {
                                allowSocialButtons: socialButtons && socialButtons.show,
                                socialButtonsColor: socialButtons && socialButtons.color,
                                socialButtonBlogStyle: socialButtons && socialButtons.blogStyle,
                                topBanner: topBanner,
                                maxWidth: "100%",
                                showMenu: true,
                                headerBackgroundColor: "white"
                            }),
                            header && /*#__PURE__*/ (0,jsx_runtime.jsx)(core_directory/* DirectoryHeaderComponent */.bS, _object_spread_props(_object_spread({}, header), {
                                searchValue: searchValue,
                                onSearchChange: this.onSearchChange
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                                className: "directories-list-wrapper",
                                children: shouldRenderEmptyState ? this.renderEmptyState() : filteredDirectories.map(this.renderDirectory)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_component["default"], {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(core_addons_component/* default */.Z, {
                                exitPopup: exitPopup,
                                exitPopupConfig: exitPopupConfig
                            })
                        ]
                    })
                }));
            }
        }
    ]);
    return MultipleDirectoryImagesTemplate;
}(react.PureComponent);

MultipleDirectoryImagesTemplate.defaultProps = {
    exitPopup: true,
    pageConfig: {
        header: {
            color: "brand-red",
            text: "Multipe Directories Title",
            height: "360px",
            img: "/static/img/strips/strip-computer-coffee.png"
        },
        directories: [],
        footerSignup: {
            title: "Start using monday.com today",
            subtitle: "Try it now for free / No credit card needed"
        }
    }
};


/***/ }),

/***/ 87355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OnePagerAssetTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/top-bar-new/top-bar-component.js + 33 modules
var top_bar_component = __webpack_require__(21882);
// EXTERNAL MODULE: ./components/addons/core-addons/core-addons-component.js + 8 modules
var core_addons_component = __webpack_require__(48124);
// EXTERNAL MODULE: ./components/templates/base-template.js + 50 modules
var base_template = __webpack_require__(44723);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/one-pager/asset-part/asset-part-component.js + 1 modules
var asset_part_component = __webpack_require__(44133);
// EXTERNAL MODULE: ./components/core/one-pager/desktop-content/text-part/text-part-component.js + 5 modules
var text_part_component = __webpack_require__(63126);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/templates/one-pager-asset-template/one-pager-asset-content/desktop-content/desktop-content-component.scss.js


var StyledDesktopContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e44zhjk0"
})("height:100%;.asset-part-wrapper{width:100%;height:100%;}.text-part-wrapper{position:absolute;top:0;bottom:0;left:0;width:56vw;display:flex;align-items:center;padding:16px 0 16px 80px;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.text-part-wrapper{padding:16px 0 16px 54px;}}");

;// CONCATENATED MODULE: ./components/templates/one-pager-asset-template/one-pager-asset-content/desktop-content/desktop-content-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var DesktopContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(DesktopContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(DesktopContentComponent);
    function DesktopContentComponent() {
        (0,_class_call_check/* default */.Z)(this, DesktopContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(DesktopContentComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, assetPart = _props.assetPart, textPart = _props.textPart, _signupForm = _props.signupForm, signupForm = _signupForm === void 0 ? {} : _signupForm, collaborationWith = _props.collaborationWith, popupVideo = _props.popupVideo, abTests = _props.abTests;
                signupForm.focusOnLoad = true;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDesktopContentComponent, {
                    className: "desktop-content-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "asset-part-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_part_component/* default */.Z, {
                                assetType: assetPart.type,
                                assetProps: assetPart.props
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-part-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_part_component/* default */.Z, _object_spread_props(_object_spread({}, textPart), {
                                signupForm: signupForm,
                                collaborationWith: collaborationWith,
                                popupVideo: popupVideo
                            }))
                        })
                    ]
                });
            }
        }
    ]);
    return DesktopContentComponent;
}(react.PureComponent);
/* harmony default export */ var desktop_content_component = ((0,ab_tests_context/* withAbTests */.k)(DesktopContentComponent));

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./components/core/one-pager/mobile-content/text-part/text-part-component.js + 3 modules
var text_part_text_part_component = __webpack_require__(57858);
// EXTERNAL MODULE: ./services/community/url-service.js
var url_service = __webpack_require__(932);
;// CONCATENATED MODULE: ./components/core/one-pager/mobile-asset-content/mobile-asset-content-component.scss.js
var _defaultExport = new String(".mobile-asset-content-component{height:100%;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center;-webkit-background-size:cover!important;-moz-background-size:cover!important;-o-background-size:cover!important;background-size:cover!important;.text-part-component{.subtitle-lines-wrapper{margin-bottom:24px!important}}.asset-part-wrapper{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;width:100vw;position:relative;padding-top:24px;.asset-part{width:100%;height:100%;position:absolute;-webkit-background-size:contain;-moz-background-size:contain;-o-background-size:contain;background-size:contain;background-repeat:no-repeat;background-position:center}}}");
_defaultExport.__hash = "d8c69559db605e67";
/* harmony default export */ var mobile_asset_content_component_scss = (_defaultExport);

;// CONCATENATED MODULE: ./components/core/one-pager/mobile-asset-content/mobile-asset-content-component.js




function mobile_asset_content_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function mobile_asset_content_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            mobile_asset_content_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function mobile_asset_content_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function mobile_asset_content_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        mobile_asset_content_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var MobileAssetContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MobileAssetContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(MobileAssetContentComponent);
    function MobileAssetContentComponent() {
        (0,_class_call_check/* default */.Z)(this, MobileAssetContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(MobileAssetContentComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, textPart = _props.textPart, mobileAssetType = _props.mobileAssetType, signupForm = _props.signupForm, collaborationWith = _props.collaborationWith;
                collaborationWith.color = "black";
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(mobile_asset_content_component_scss.__hash) + " " + "mobile-asset-content-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(mobile_asset_content_component_scss.__hash) + " " + "text-part-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_part_text_part_component/* default */.Z, mobile_asset_content_component_object_spread_props(mobile_asset_content_component_object_spread({}, textPart), {
                                signupForm: signupForm,
                                collaborationWith: collaborationWith,
                                color: "black"
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(mobile_asset_content_component_scss.__hash) + " " + "asset-part-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    backgroundImage: "url(".concat((0,url_service.fixDevImageUrl)(mobileAssetType), ")")
                                },
                                className: "jsx-".concat(mobile_asset_content_component_scss.__hash) + " " + "asset-part"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: mobile_asset_content_component_scss.__hash,
                            children: mobile_asset_content_component_scss
                        })
                    ]
                });
            }
        }
    ]);
    return MobileAssetContentComponent;
}(react.PureComponent);

MobileAssetContentComponent.defaultProps = {
    mobileAssetType: "/static/img/one-pager/mobile/m-statuses-with-hand.gif",
    collaborationWith: {}
};

;// CONCATENATED MODULE: ./components/core/one-pager/mobile-background-gif-content/mobile-background-gif-content-component.scss.js
var mobile_background_gif_content_component_scss_defaultExport = new String(".mobile-background-gif-content-component.jsx-31f3db773df3688c{height:100%;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center;-webkit-background-size:cover!important;-moz-background-size:cover!important;-o-background-size:cover!important;background-size:cover!important;.asset-part-wrapper.jsx-31f3db773df3688c{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;width:100vw;.asset-part.jsx-31f3db773df3688c{width:100%;height:100%;-webkit-background-size:cover!important;-moz-background-size:cover!important;-o-background-size:cover!important;background-size:cover!important;background-position:center!important}}}");
mobile_background_gif_content_component_scss_defaultExport.__hash = "31f3db773df3688c";
/* harmony default export */ var mobile_background_gif_content_component_scss = (mobile_background_gif_content_component_scss_defaultExport);

;// CONCATENATED MODULE: ./components/core/one-pager/mobile-background-gif-content/mobile-background-gif-content-component.js




function mobile_background_gif_content_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function mobile_background_gif_content_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            mobile_background_gif_content_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function mobile_background_gif_content_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function mobile_background_gif_content_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        mobile_background_gif_content_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var MobileBackgroundGifContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MobileBackgroundGifContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(MobileBackgroundGifContentComponent);
    function MobileBackgroundGifContentComponent() {
        (0,_class_call_check/* default */.Z)(this, MobileBackgroundGifContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(MobileBackgroundGifContentComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, textPart = _props.textPart, backgroundAsset = _props.backgroundAsset, signupForm = _props.signupForm, collaborationWith = _props.collaborationWith;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        background: "url(".concat(backgroundAsset, ")")
                    },
                    className: "jsx-".concat(mobile_background_gif_content_component_scss.__hash) + " " + "mobile-background-gif-content-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(mobile_background_gif_content_component_scss.__hash) + " " + "text-part-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_part_text_part_component/* default */.Z, mobile_background_gif_content_component_object_spread_props(mobile_background_gif_content_component_object_spread({}, textPart), {
                                signupForm: signupForm,
                                collaborationWith: collaborationWith,
                                color: "black"
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: mobile_background_gif_content_component_scss.__hash,
                            children: mobile_background_gif_content_component_scss
                        })
                    ]
                });
            }
        }
    ]);
    return MobileBackgroundGifContentComponent;
}(react.PureComponent);

MobileBackgroundGifContentComponent.defaultProps = {
    backgroundAsset: "/static/img/one-pager/one-pager-mobile.gif",
    collaborationWith: {}
};

// EXTERNAL MODULE: ./components/segments/social-proof/social-proof-component.js + 1 modules
var social_proof_component = __webpack_require__(18925);
// EXTERNAL MODULE: ./components/segments/short-footer/short-footer-component.js
var short_footer_component = __webpack_require__(83234);
// EXTERNAL MODULE: ./constants/one-pager-asset-types.js
var one_pager_asset_types = __webpack_require__(30513);
;// CONCATENATED MODULE: ./components/templates/one-pager-asset-template/one-pager-asset-content/one-pager-asset-content-component.scss.js


var StyledOnePagerAssetContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ku8qxu0"
})("width:100vw;height:calc(100vh - 65px);position:relative;overflow:hidden;.desktop-content-wrapper{display:block;height:100%;}.mobile-content-wrapper{display:none;height:100%;}&.multiple-folds{overflow:visible;.desktop-content-wrapper{height:auto;.desktop-content-component{.asset-part-wrapper{.asset-part-component{.video-component{.react-player-video-component{video{width:100vw !important;height:calc(100vh - 65px) !important;object-fit:cover;}}}}}}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){height:calc(100vh - 54px);.desktop-content-wrapper{display:none;}.mobile-content-wrapper{display:block;}}");

;// CONCATENATED MODULE: ./components/templates/one-pager-asset-template/one-pager-asset-content/one-pager-asset-content-component.js




function one_pager_asset_content_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function one_pager_asset_content_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            one_pager_asset_content_component_define_property(target, key, source[key]);
        });
    }
    return target;
}










var OnePagerAssetContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(OnePagerAssetContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(OnePagerAssetContentComponent);
    function OnePagerAssetContentComponent() {
        (0,_class_call_check/* default */.Z)(this, OnePagerAssetContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(OnePagerAssetContentComponent, [
        {
            key: "getMobileVersion",
            value: function getMobileVersion() {
                var mobileVersion = this.props.mobileVersion;
                if (mobileVersion === one_pager_asset_types/* MOBILE_VERSIONS.MOBILE_ASSET */.m.MOBILE_ASSET) {
                    return MobileAssetContentComponent;
                }
                return MobileBackgroundGifContentComponent;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, SocialProof = _props.SocialProof, ShortFooter = _props.ShortFooter;
                var showSocialProof = SocialProof.showSocialProof, socialProofContent = SocialProof.content;
                var showShortFooter = ShortFooter.showShortFooter, shortFooterContent = ShortFooter.content;
                var MobileComponent = this.getMobileVersion();
                var hasMultipleFolds = showSocialProof || showShortFooter;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOnePagerAssetContentComponent, {
                    className: classnames_default()("one-pager-asset-content-component", {
                        "multiple-folds": hasMultipleFolds
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "desktop-content-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_content_component, one_pager_asset_content_component_object_spread({}, this.props)),
                                showSocialProof && /*#__PURE__*/ (0,jsx_runtime.jsx)(social_proof_component/* default */.Z, one_pager_asset_content_component_object_spread({}, socialProofContent)),
                                showShortFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer_component/* default */.Z, one_pager_asset_content_component_object_spread({}, shortFooterContent))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-content-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileComponent, one_pager_asset_content_component_object_spread({}, this.props))
                        })
                    ]
                });
            }
        }
    ]);
    return OnePagerAssetContentComponent;
}(react.PureComponent);

OnePagerAssetContentComponent.defaultProps = {
    assetPart: {},
    textPart: {},
    collaborationWith: {},
    mobileVersion: one_pager_asset_types/* MOBILE_VERSIONS.MOBILE_BACKGROUND_GIF */.m.MOBILE_BACKGROUND_GIF,
    SocialProof: {},
    ShortFooter: {}
};

;// CONCATENATED MODULE: ./components/templates/one-pager-asset-template/one-pager-asset-template.js




function one_pager_asset_template_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function one_pager_asset_template_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            one_pager_asset_template_define_property(target, key, source[key]);
        });
    }
    return target;
}
function one_pager_asset_template_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function one_pager_asset_template_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        one_pager_asset_template_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var OnePagerAssetTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(OnePagerAssetTemplate, PureComponent);
    var _super = (0,_create_super/* default */.Z)(OnePagerAssetTemplate);
    function OnePagerAssetTemplate() {
        (0,_class_call_check/* default */.Z)(this, OnePagerAssetTemplate);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(OnePagerAssetTemplate, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, headerUrl = _props.headerUrl, exitPopup = _props.exitPopup, loginTheme = _props.loginTheme, menuTheme = _props.menuTheme, stickyMode = _props.stickyMode, pageConfig = _props.pageConfig;
                var headerStrip = pageConfig.headerStrip, parts = pageConfig.parts, footerSignup = pageConfig.footerSignup, nameSignature = pageConfig.nameSignature, socialButtons = pageConfig.socialButtons, topBanner = pageConfig.topBanner, exitPopupConfig = pageConfig.exitPopupConfig;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_template/* default */.Z, one_pager_asset_template_object_spread_props(one_pager_asset_template_object_spread({}, this.props, pageConfig), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(top_bar_component/* default */.Z, {
                            url: headerUrl,
                            loginTheme: loginTheme,
                            menuTheme: menuTheme,
                            showMenu: false,
                            stickyMode: stickyMode,
                            allowSocialButtons: socialButtons && socialButtons.show,
                            socialButtonsColor: socialButtons && socialButtons.color,
                            topBanner: topBanner,
                            maxWidth: "100%",
                            headerBackgroundColor: "transparent"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OnePagerAssetContentComponent, one_pager_asset_template_object_spread({}, pageConfig))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(core_addons_component/* default */.Z, {
                            exitPopup: exitPopup,
                            exitPopupConfig: exitPopupConfig
                        })
                    ]
                }));
            }
        }
    ]);
    return OnePagerAssetTemplate;
}(react.PureComponent);

OnePagerAssetTemplate.defaultProps = {
    headerUrl: "https://monday.com/",
    title: "monday.com",
    description: "",
    exitPopup: true,
    menuTheme: "",
    loginTheme: ""
};


/***/ }),

/***/ 36278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MobileOnePagerWithImageTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/top-bar-new/top-bar-component.js + 33 modules
var top_bar_component = __webpack_require__(21882);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/base-footer/base-footer-component.js + 1 modules
var base_footer_component = __webpack_require__(44574);
// EXTERNAL MODULE: ./components/addons/core-addons/core-addons-component.js + 8 modules
var core_addons_component = __webpack_require__(48124);
// EXTERNAL MODULE: ./components/templates/base-template.js + 50 modules
var base_template = __webpack_require__(44723);
// EXTERNAL MODULE: ./components/templates/one-pager-with-image-template/one-pager-with-image-content/mobile-content/mobile-content-component.js + 1 modules
var mobile_content_component = __webpack_require__(73098);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/templates/one-pager-with-image-template/mobile-only/content/mobile-one-pager-with-image-content-component.scss.js


var StyledMobileOnePagerWithImageContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1336fwf0"
})("width:100vw;display:inline-flex;justify-content:space-around;.mobile-content-wrapper{display:flex;z-index:", z_index/* LAYER_ONE */.KW, ";justify-content:center;align-items:center;}");

;// CONCATENATED MODULE: ./components/templates/one-pager-with-image-template/mobile-only/content/mobile-one-pager-with-image-content-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var MobileOnePagerWithImageContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MobileOnePagerWithImageContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(MobileOnePagerWithImageContentComponent);
    function MobileOnePagerWithImageContentComponent() {
        (0,_class_call_check/* default */.Z)(this, MobileOnePagerWithImageContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(MobileOnePagerWithImageContentComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMobileOnePagerWithImageContentComponent, {
                    className: "mobile-one-pager-with-image-content-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mobile-content-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_content_component/* default */.Z, _object_spread_props(_object_spread({}, this.props), {
                            isMobileOnly: true
                        }))
                    })
                });
            }
        }
    ]);
    return MobileOnePagerWithImageContentComponent;
}(react.PureComponent);

MobileOnePagerWithImageContentComponent.defaultProps = {
    textPart: {},
    imageWithBackgroundPart: {},
    collaborationWith: {}
};

;// CONCATENATED MODULE: ./components/templates/one-pager-with-image-template/mobile-only/mobile-one-pager-with-image-template.js




function mobile_one_pager_with_image_template_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function mobile_one_pager_with_image_template_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            mobile_one_pager_with_image_template_define_property(target, key, source[key]);
        });
    }
    return target;
}
function mobile_one_pager_with_image_template_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function mobile_one_pager_with_image_template_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        mobile_one_pager_with_image_template_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var MobileOnePagerWithImageTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MobileOnePagerWithImageTemplate, PureComponent);
    var _super = (0,_create_super/* default */.Z)(MobileOnePagerWithImageTemplate);
    function MobileOnePagerWithImageTemplate(props) {
        (0,_class_call_check/* default */.Z)(this, MobileOnePagerWithImageTemplate);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(MobileOnePagerWithImageTemplate, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, exitPopup = _props.exitPopup, stickyMode = _props.stickyMode, pageConfig = _props.pageConfig;
                var socialButtons = pageConfig.socialButtons, footer = pageConfig.footer, topbar = pageConfig.topbar, topBanner = pageConfig.topBanner, exitPopupConfig = pageConfig.exitPopupConfig;
                var topbarConfig = topbar || {};
                var footerConfig = footer || {};
                var showHeader = topbarConfig.showMenu || false;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_template/* default */.Z, mobile_one_pager_with_image_template_object_spread_props(mobile_one_pager_with_image_template_object_spread({}, this.props, pageConfig), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(top_bar_component/* default */.Z, {
                            loginTheme: topbarConfig.loginTheme,
                            menuTheme: topbarConfig.menuTheme,
                            showMenu: showHeader,
                            headerBackgroundColor: "white",
                            stickyMode: stickyMode,
                            allowSocialButtons: socialButtons && socialButtons.show,
                            socialButtonsColor: socialButtons && socialButtons.color,
                            mobileLogoTheme: "dark-theme",
                            topBanner: topBanner,
                            maxWidth: "100%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOnePagerWithImageContentComponent, mobile_one_pager_with_image_template_object_spread({}, pageConfig))
                        }),
                        !footerConfig.preventFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "footer-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_footer_component["default"], {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(core_addons_component/* default */.Z, {
                            exitPopup: exitPopup,
                            exitPopupConfig: exitPopupConfig
                        })
                    ]
                }));
            }
        }
    ]);
    return MobileOnePagerWithImageTemplate;
}(react.PureComponent);

MobileOnePagerWithImageTemplate.defaultProps = {
    title: "monday.com",
    description: "",
    exitPopup: true
};


/***/ }),

/***/ 8264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OnePagerWithImageTemplate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_top_bar_new_top_bar_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21882);
/* harmony import */ var segments_desktop_footer_layouts_base_footer_base_footer_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44574);
/* harmony import */ var _components_addons_core_addons_core_addons_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48124);
/* harmony import */ var _components_templates_base_template__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44723);
/* harmony import */ var _one_pager_with_image_content_one_pager_with_image_content_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40119);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var OnePagerWithImageTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(OnePagerWithImageTemplate, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(OnePagerWithImageTemplate);
    function OnePagerWithImageTemplate(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(this, OnePagerWithImageTemplate);
        return _super.call(this, props);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(OnePagerWithImageTemplate, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, exitPopup = _props.exitPopup, stickyMode = _props.stickyMode, pageConfig = _props.pageConfig;
                var socialButtons = pageConfig.socialButtons, footer = pageConfig.footer, topbar = pageConfig.topbar, topBanner = pageConfig.topBanner, exitPopupConfig = pageConfig.exitPopupConfig;
                var topbarConfig = topbar || {};
                var footerConfig = footer || {};
                var showHeader = topbarConfig.showMenu || false;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_templates_base_template__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, _object_spread_props(_object_spread({}, this.props, pageConfig), {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_top_bar_new_top_bar_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            loginTheme: topbarConfig.loginTheme,
                            menuTheme: topbarConfig.menuTheme,
                            showMenu: showHeader,
                            shortHeader: topbarConfig.shortHeader,
                            headerBackgroundColor: "white",
                            stickyMode: stickyMode,
                            allowSocialButtons: socialButtons && socialButtons.show,
                            socialButtonsColor: socialButtons && socialButtons.color,
                            mobileLogoTheme: "dark-theme",
                            topBanner: topBanner,
                            maxWidth: "100%"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_one_pager_with_image_content_one_pager_with_image_content_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, _object_spread({}, pageConfig))
                        }),
                        !footerConfig.preventFooter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "footer-wrapper",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(segments_desktop_footer_layouts_base_footer_base_footer_component__WEBPACK_IMPORTED_MODULE_3__["default"], {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_addons_core_addons_core_addons_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            exitPopup: exitPopup,
                            exitPopupConfig: exitPopupConfig
                        })
                    ]
                }));
            }
        }
    ]);
    return OnePagerWithImageTemplate;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

OnePagerWithImageTemplate.defaultProps = {
    title: "monday.com",
    description: "",
    exitPopup: true
};


/***/ }),

/***/ 55114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OnePagerWithVideoTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/top-bar-new/top-bar-component.js + 33 modules
var top_bar_component = __webpack_require__(21882);
// EXTERNAL MODULE: ./components/addons/core-addons/core-addons-component.js + 8 modules
var core_addons_component = __webpack_require__(48124);
// EXTERNAL MODULE: ./components/templates/base-template.js + 50 modules
var base_template = __webpack_require__(44723);
// EXTERNAL MODULE: ./components/core/one-pager/desktop-content/text-part/text-part-component.js + 5 modules
var text_part_component = __webpack_require__(63126);
// EXTERNAL MODULE: ./components/core/one-pager/asset-part/asset-part-component.js + 1 modules
var asset_part_component = __webpack_require__(44133);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/templates/one-pager-with-video-template/one-pager-with-video-content/desktop-content/desktop-content-component.scss.js




var StyledDesktopContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e11xjymf0"
})("height:100%;display:flex;align-items:center;.text-part-wrapper{width:50vw;display:flex;align-items:center;padding:16px 0 16px 80px;}.asset-part-wrapper{width:50vw;height:100vh;top:0;right:0;overflow:hidden;position:fixed;.intro-video-button-wrapper{position:absolute;top:0;left:0;right:0;bottom:0;z-index:", z_index/* TOP_LAYER */.nA, ";display:flex;align-items:center;justify-content:center;.intro-video-button{cursor:pointer;display:flex;flex-direction:column;justify-content:center;align-items:center;&:hover{.intro-video-button-image{transform:scale(1.1);}}.intro-video-button-image{margin-top:10vh;width:20vh;transition:transform 0.1s ease-in-out;}.intro-video-button-text{color:", colors/* default.white */.Z.white, ";background-color:", colors/* default.black */.Z.black, ";padding:12px 24px;border-radius:10px;margin-top:32px;font-size:3vh;outline:none;}}}}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.text-part-wrapper{padding:16px 0 16px 54px;}}");

;// CONCATENATED MODULE: ./components/templates/one-pager-with-video-template/one-pager-with-video-content/desktop-content/desktop-content-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var DesktopContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(DesktopContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(DesktopContentComponent);
    function DesktopContentComponent() {
        (0,_class_call_check/* default */.Z)(this, DesktopContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(DesktopContentComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, onPlayButtonClicked = _props.onPlayButtonClicked, assetPart = _props.assetPart, textPart = _props.textPart, _signupForm = _props.signupForm, signupForm = _signupForm === void 0 ? {} : _signupForm, collaborationWith = _props.collaborationWith, imageWithBackgroundPart = _props.imageWithBackgroundPart, popupVideo = _props.popupVideo, abTests = _props.abTests;
                signupForm.focusOnLoad = true;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDesktopContentComponent, {
                    className: "desktop-content-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-part-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_part_component/* default */.Z, _object_spread_props(_object_spread({}, textPart), {
                                signupForm: signupForm,
                                collaborationWith: collaborationWith
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "asset-part-wrapper",
                            children: [
                                popupVideo.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "intro-video-button-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        onClick: onPlayButtonClicked,
                                        className: "intro-video-button",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "intro-video-button-image",
                                                src: "/static/img/one-pager/black-play-button.png",
                                                alt: "play video button"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "intro-video-button-text",
                                                children: popupVideo.playButtonText
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_part_component/* default */.Z, {
                                    assetType: assetPart.type,
                                    assetProps: assetPart.props,
                                    theme: "half-width"
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return DesktopContentComponent;
}(react.PureComponent);
/* harmony default export */ var desktop_content_component = ((0,ab_tests_context/* withAbTests */.k)(DesktopContentComponent));
DesktopContentComponent.defaultProps = {
    popupVideo: {}
};

// EXTERNAL MODULE: ./components/core/one-pager/mobile-content/text-part/text-part-component.js + 3 modules
var text_part_text_part_component = __webpack_require__(57858);
;// CONCATENATED MODULE: ./components/templates/one-pager-with-video-template/one-pager-with-video-content/mobile-content/mobile-content-component.scss.js

var StyledMobileContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e143jree0"
})("height:100%;width:100vw;display:flex;justify-content:center;align-items:center;background-size:cover;padding-bottom:54px;");

;// CONCATENATED MODULE: ./components/templates/one-pager-with-video-template/one-pager-with-video-content/mobile-content/mobile-content-component.js




function mobile_content_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function mobile_content_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            mobile_content_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function mobile_content_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function mobile_content_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        mobile_content_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var MobileContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MobileContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(MobileContentComponent);
    function MobileContentComponent() {
        (0,_class_call_check/* default */.Z)(this, MobileContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(MobileContentComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, textPart = _props.textPart, backgroundAsset = _props.backgroundAsset, signupForm = _props.signupForm, collaborationWith = _props.collaborationWith;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMobileContentComponent, {
                    className: "mobile-content-component",
                    style: {
                        backgroundImage: "url(".concat(backgroundAsset, ")")
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-part-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_part_text_part_component/* default */.Z, mobile_content_component_object_spread_props(mobile_content_component_object_spread({}, textPart), {
                            signupForm: signupForm,
                            collaborationWith: collaborationWith,
                            color: "black"
                        }))
                    })
                });
            }
        }
    ]);
    return MobileContentComponent;
}(react.PureComponent);

MobileContentComponent.defaultProps = {
    backgroundAsset: "/static/img/one-pager/one-pager-mobile.gif",
    collaborationWith: {}
};

// EXTERNAL MODULE: ./components/core/youtube-video-modal/youtube-video-modal-component.js + 7 modules
var youtube_video_modal_component = __webpack_require__(60202);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
;// CONCATENATED MODULE: ./components/templates/one-pager-with-video-template/one-pager-with-video-content/one-pager-with-video-content-component.scss.js



var StyledOnePagerVideoContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1cham090"
})("width:100vw;height:calc(100vh - 65px);display:inline-flex;justify-content:flex-start;.mobile-content-wrapper{display:none;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){height:calc(100vh - 54px);display:flex;flex-direction:column;align-items:center;justify-content:center;.desktop-content-wrapper{display:none;}.mobile-content-wrapper{display:flex;z-index:", z_index/* LAYER_ONE */.KW, ";justify-content:center;align-items:center;height:100%;}}");

;// CONCATENATED MODULE: ./components/templates/one-pager-with-video-template/one-pager-with-video-content/one-pager-with-video-content-component.js





function one_pager_with_video_content_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function one_pager_with_video_content_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            one_pager_with_video_content_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function one_pager_with_video_content_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function one_pager_with_video_content_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        one_pager_with_video_content_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var OnePagerVideoContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(OnePagerVideoContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(OnePagerVideoContentComponent);
    function OnePagerVideoContentComponent(props) {
        (0,_class_call_check/* default */.Z)(this, OnePagerVideoContentComponent);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            openModal: false
        };
        _this.onPlayButtonClicked = _this.onPlayButtonClicked.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.closeModal = _this.closeModal.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(OnePagerVideoContentComponent, [
        {
            key: "onPlayButtonClicked",
            value: function onPlayButtonClicked() {
                var popupVideo = this.props.popupVideo;
                BigBrain("track", bigbrain_event_types.YOUTUBE_MODAL_OPEN, {
                    kind: popupVideo.playButtonText
                });
                this.setState({
                    openModal: true
                });
            }
        },
        {
            key: "closeModal",
            value: function closeModal() {
                var popupVideo = this.props.popupVideo;
                BigBrain("track", bigbrain_event_types.YOUTUBE_MODAL_CLOSE, {
                    kind: popupVideo.playButtonText
                });
                this.setState({
                    openModal: false
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var openModal = this.state.openModal;
                var _props = this.props, popupVideo = _props.popupVideo, forceClosePopup = _props.forceClosePopup;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOnePagerVideoContentComponent, {
                    className: "one-pager-with-video-content-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "desktop-content-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_content_component, one_pager_with_video_content_component_object_spread_props(one_pager_with_video_content_component_object_spread({}, this.props), {
                                onPlayButtonClicked: this.onPlayButtonClicked
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-content-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileContentComponent, one_pager_with_video_content_component_object_spread({}, this.props))
                        }),
                        popupVideo.show && !forceClosePopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_video_modal_component/* default */.Z, one_pager_with_video_content_component_object_spread_props(one_pager_with_video_content_component_object_spread({}, popupVideo), {
                            minHeight: 546,
                            isOpen: openModal,
                            opts: {
                                width: 970,
                                height: 546,
                                playerVars: {
                                    autoplay: 1,
                                    rel: 0,
                                    showinfo: 0
                                }
                            },
                            onCloseModal: this.closeModal
                        }))
                    ]
                });
            }
        }
    ]);
    return OnePagerVideoContentComponent;
}(react.PureComponent);

OnePagerVideoContentComponent.defaultProps = {
    textPart: {},
    imageWithBackgroundPart: {},
    collaborationWith: {},
    popupVideo: {}
};

;// CONCATENATED MODULE: ./components/templates/one-pager-with-video-template/one-pager-with-video-template.js





function one_pager_with_video_template_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function one_pager_with_video_template_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            one_pager_with_video_template_define_property(target, key, source[key]);
        });
    }
    return target;
}
function one_pager_with_video_template_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function one_pager_with_video_template_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        one_pager_with_video_template_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var OnePagerWithVideoTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(OnePagerWithVideoTemplate, PureComponent);
    var _super = (0,_create_super/* default */.Z)(OnePagerWithVideoTemplate);
    function OnePagerWithVideoTemplate(props) {
        (0,_class_call_check/* default */.Z)(this, OnePagerWithVideoTemplate);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            forceClosePopup: false
        };
        _this.onExitIntentCallback = _this.onExitIntentCallback.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onCloseExitPopupCallback = _this.onCloseExitPopupCallback.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(OnePagerWithVideoTemplate, [
        {
            key: "onExitIntentCallback",
            value: function onExitIntentCallback() {
                this.setState({
                    forceClosePopup: true
                });
            }
        },
        {
            key: "onCloseExitPopupCallback",
            value: function onCloseExitPopupCallback() {
                this.setState({
                    forceClosePopup: false
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, headerUrl = _props.headerUrl, exitPopup = _props.exitPopup, loginTheme = _props.loginTheme, menuTheme = _props.menuTheme, stickyMode = _props.stickyMode, pageConfig = _props.pageConfig;
                var headerStrip = pageConfig.headerStrip, parts = pageConfig.parts, footerSignup = pageConfig.footerSignup, nameSignature = pageConfig.nameSignature, socialButtons = pageConfig.socialButtons, topBanner = pageConfig.topBanner, exitPopupConfig = pageConfig.exitPopupConfig;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_template/* default */.Z, one_pager_with_video_template_object_spread_props(one_pager_with_video_template_object_spread({}, this.props, pageConfig), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(top_bar_component/* default */.Z, {
                            url: headerUrl,
                            loginTheme: loginTheme,
                            menuTheme: menuTheme,
                            showMenu: false,
                            stickyMode: stickyMode,
                            allowSocialButtons: socialButtons && socialButtons.show,
                            socialButtonsColor: socialButtons && socialButtons.color,
                            mobileLogoTheme: "dark-theme",
                            topBanner: topBanner,
                            maxWidth: "100%",
                            headerBackgroundColor: "transparent"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OnePagerVideoContentComponent, one_pager_with_video_template_object_spread_props(one_pager_with_video_template_object_spread({}, pageConfig), {
                                forceClosePopup: this.state.forceClosePopup
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(core_addons_component/* default */.Z, {
                            exitPopup: exitPopup,
                            exitPopupConfig: exitPopupConfig
                        })
                    ]
                }));
            }
        }
    ]);
    return OnePagerWithVideoTemplate;
}(react.PureComponent);

OnePagerWithVideoTemplate.defaultProps = {
    headerUrl: "https://monday.com/",
    title: "monday.com",
    description: "",
    exitPopup: true,
    menuTheme: "",
    loginTheme: ""
};


/***/ }),

/***/ 8335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LongTemplateNew; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/addons/core-addons/core-addons-component.js + 8 modules
var core_addons_component = __webpack_require__(48124);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-component.js + 81 modules
var base_header_component = __webpack_require__(33782);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.js + 1 modules
var long_footer_component = __webpack_require__(55408);
// EXTERNAL MODULE: ./constants/element-ids.js
var element_ids = __webpack_require__(53219);
// EXTERNAL MODULE: ./components/templates/base-template.js + 50 modules
var base_template = __webpack_require__(44723);
// EXTERNAL MODULE: ./node_modules/above-the-fold-only-server-render/lib/index.js
var lib = __webpack_require__(38582);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/is-mobile/index.js
var is_mobile = __webpack_require__(63805);
var is_mobile_default = /*#__PURE__*/__webpack_require__.n(is_mobile);
// EXTERNAL MODULE: ./components/segments/index.js + 96 modules
var segments = __webpack_require__(91237);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/segments/base-layout-segment/base-layout-segment-component.scss.js


var StyledBaseLayoutSegmentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1j4ib2h0"
})("box-sizing:content-box;.segment-content-container{&:not(.full-width){max-width:", vp_sizes/* MAX_DESKTOP_CONTENT_WIDTH */.O$, "px;}margin:auto;}@media (max-width:", vp_sizes/* MAX_DESKTOP_CONTENT_WIDTH */.O$, "px){padding:0 24px;}");

// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/preview-base-segment-context.js + 4 modules
var preview_base_segment_context = __webpack_require__(70349);
;// CONCATENATED MODULE: ./components/segments/base-layout-segment/base-layout-segment-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var BaseLayoutSegmentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BaseLayoutSegmentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BaseLayoutSegmentComponent);
    function BaseLayoutSegmentComponent() {
        (0,_class_call_check/* default */.Z)(this, BaseLayoutSegmentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BaseLayoutSegmentComponent, [
        {
            key: "getSegmentComponent",
            value: function getSegmentComponent() {
                var segment = this.props.segment;
                return segments/* default */.Z[segment.type];
            }
        },
        {
            key: "getSegmentBackgroundColor",
            value: function getSegmentBackgroundColor() {
                return this.props.segment.props.backgroundColor;
            }
        },
        {
            key: "getSegmentTextColor",
            value: function getSegmentTextColor() {
                return this.props.segment.props.textColor;
            }
        },
        {
            key: "getSegmentStyleOverride",
            value: function getSegmentStyleOverride() {
                return this.getSegmentComponent().baseSegmentStyleOverride || {};
            }
        },
        {
            key: "getSegmentStyle",
            value: function getSegmentStyle() {
                var segment = this.props.segment;
                var _props = segment.props, mobilePaddingTop = _props.mobilePaddingTop, mobilePaddingBottom = _props.mobilePaddingBottom, paddingTop = _props.paddingTop, paddingBottom = _props.paddingBottom;
                if (is_mobile_default()()) {
                    paddingTop = mobilePaddingTop || paddingTop;
                    paddingBottom = mobilePaddingBottom || paddingBottom;
                }
                var backgroundColor = colors/* default */.Z[this.getSegmentBackgroundColor()];
                var color = colors/* default */.Z[this.getSegmentTextColor()];
                var segmentStyleOverride = this.getSegmentStyleOverride();
                return _object_spread({
                    backgroundColor: backgroundColor,
                    color: color,
                    paddingTop: paddingTop,
                    paddingBottom: paddingBottom
                }, segmentStyleOverride);
            }
        },
        {
            key: "shouldHideSegment",
            value: function shouldHideSegment() {
                var segment = this.props.segment;
                var showSegment = segment.props.showSegment;
                var isMobileMode = is_mobile_default()();
                var isMobileOnly = showSegment === "mobile";
                var isDesktopOnly = showSegment === "desktop";
                var shouldHideSegment1 = isMobileOnly && !isMobileMode || isDesktopOnly && isMobileMode;
                return shouldHideSegment1;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, segment = _props.segment, isUserLoggedIn = _props.isUserLoggedIn, extraProps = _props.extraProps;
                var isFullWidth = segment.props.isFullWidth;
                var SegmentComponent = this.getSegmentComponent();
                if (!SegmentComponent) return null;
                var SegmentComponentWithGenericConfig = (0,generic_config_context/* withGenericConfig */.P)(SegmentComponent);
                var style = this.getSegmentStyle();
                if (this.shouldHideSegment()) {
                    // not showing this segment for current mode
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "empty-segment"
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBaseLayoutSegmentComponent, {
                    className: "base-layout-segment-component",
                    style: style,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("segment-content-container", {
                            "full-width": isFullWidth
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SegmentComponentWithGenericConfig, _object_spread_props(_object_spread({}, extraProps, segment.props), {
                            isUserLoggedIn: isUserLoggedIn
                        }))
                    })
                });
            }
        }
    ]);
    return BaseLayoutSegmentComponent;
}(react.PureComponent);
BaseLayoutSegmentComponent.defaultProps = {
    extraProps: {}
};
var BaseLayoutSegmentWrapperComponent = function(props) {
    var isPreview = props.isPreview;
    var Component = isPreview ? (0,preview_base_segment_context/* withPreviewBaseSegment */.I)(BaseLayoutSegmentComponent) : BaseLayoutSegmentComponent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _object_spread({}, props));
};
/* harmony default export */ var base_layout_segment_component = (BaseLayoutSegmentWrapperComponent);

// EXTERNAL MODULE: ./contexts/segment-context.js
var segment_context = __webpack_require__(39944);
;// CONCATENATED MODULE: ./components/segments/segments-layout-list/segments-layout-list-component.js









var SegmentsLayoutListComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SegmentsLayoutListComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SegmentsLayoutListComponent);
    function SegmentsLayoutListComponent() {
        (0,_class_call_check/* default */.Z)(this, SegmentsLayoutListComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SegmentsLayoutListComponent, [
        {
            key: "shouldRenderSegmentOnServer",
            value: function shouldRenderSegmentOnServer(segmentIndex) {
                var numberOfAboveTheFoldSegments = this.props.numberOfAboveTheFoldSegments;
                numberOfAboveTheFoldSegments = parseInt(numberOfAboveTheFoldSegments);
                if (!numberOfAboveTheFoldSegments) return true;
                return segmentIndex < numberOfAboveTheFoldSegments;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, segments = _props.segments, isPreview = _props.isPreview, isUserLoggedIn = _props.isUserLoggedIn, extraProps = _props.extraProps;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "segments-layout-list-component",
                    id: "segments-layout-list-component",
                    children: segments.map(function(segment, index) {
                        var allowSSR = _this.shouldRenderSegmentOnServer(index);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* AboveTheFoldOnlyServerRender */.bP, {
                            skip: !allowSSR,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(segment_context/* SegmentContext.Provider */.k.Provider, {
                                value: {
                                    isFirstSegment: index === 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_layout_segment_component, {
                                    isPreview: isPreview,
                                    extraProps: extraProps,
                                    segment: segment,
                                    isUserLoggedIn: isUserLoggedIn,
                                    index: index
                                })
                            })
                        }, index);
                    })
                });
            }
        }
    ]);
    return SegmentsLayoutListComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/templates/segments-template/segments-template.js




function segments_template_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function segments_template_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            segments_template_define_property(target, key, source[key]);
        });
    }
    return target;
}
function segments_template_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function segments_template_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        segments_template_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



 //new for monday 2.0
 // //new for monday 2.0



var LongTemplateNew = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LongTemplateNew, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LongTemplateNew);
    function LongTemplateNew() {
        (0,_class_call_check/* default */.Z)(this, LongTemplateNew);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(LongTemplateNew, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, headerUrl = _props.headerUrl, exitPopup = _props.exitPopup, stickyMode = _props.stickyMode, pageConfig = _props.pageConfig, isPreview = _props.isPreview;
                var segments = pageConfig.segments, topbar = pageConfig.topbar, footer = pageConfig.footer, socialButtons = pageConfig.socialButtons, topBanner = pageConfig.topBanner, exitPopupConfig = pageConfig.exitPopupConfig, aboveTheFoldSegmentsNumber = pageConfig.aboveTheFoldSegmentsNumber;
                var preventFooter = footer && footer.preventFooter;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(base_template/* default */.Z, segments_template_object_spread_props(segments_template_object_spread({}, this.props, pageConfig), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_header_component["default"], segments_template_object_spread_props(segments_template_object_spread({}, topbar), {
                                url: headerUrl,
                                headerBackgroundColor: "white",
                                stickyMode: stickyMode,
                                allowSocialButtons: socialButtons && socialButtons.show,
                                socialButtonsColor: socialButtons && socialButtons.color,
                                socialButtonBlogStyle: socialButtons && socialButtons.blogStyle,
                                topBanner: topBanner
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                                id: element_ids/* MAIN_ID */.k,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SegmentsLayoutListComponent, {
                                    isPreview: isPreview,
                                    segments: segments,
                                    numberOfAboveTheFoldSegments: aboveTheFoldSegmentsNumber
                                })
                            }),
                            !preventFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_component["default"], segments_template_object_spread({
                                showTrustpilotReviews: pageConfig.showTrustpilotReviews
                            }, footer)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(core_addons_component/* default */.Z, {
                                exitPopup: exitPopup,
                                exitPopupConfig: exitPopupConfig
                            })
                        ]
                    })
                }));
            }
        }
    ]);
    return LongTemplateNew;
}(react.PureComponent);

LongTemplateNew.defaultProps = {
    headerUrl: "https://monday.com/",
    title: "monday.com",
    description: "",
    exitPopup: true,
    topbar: {}
};


/***/ }),

/***/ 30513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ MOBILE_VERSIONS; }
/* harmony export */ });
var MOBILE_VERSIONS = {
    MOBILE_ASSET: "MOBILE_ASSET",
    MOBILE_BACKGROUND_GIF: "MOBILE_BACKGROUND_GIF"
};


/***/ }),

/***/ 53021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ slim_footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./components/core/short-footer/short-footer.js + 4 modules
var short_footer = __webpack_require__(69861);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-category/footer-category-component.js + 1 modules
var footer_category_component = __webpack_require__(70212);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.scss.js
var long_footer_scss = __webpack_require__(17619);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/footer-bottom-bar-component.js + 10 modules
var footer_bottom_bar_component = __webpack_require__(46374);
// EXTERNAL MODULE: ./services/localization/localization-service.js
var localization_service = __webpack_require__(99952);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./segments/desktop/core-components/slim-footer/default-props.js
/* harmony default export */ var default_props = ({});

;// CONCATENATED MODULE: ./segments/desktop/core-components/slim-footer/slim-footer.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}











var SlimFooter = function(props) {
    var translate = props.translate, localeId = props.localeId, abTests = props.abTests, pageClusterConfig = props.pageClusterConfig, useProductMiniSiteConfig = props.useProductMiniSiteConfig;
    var SLIM_FOOTER = "slim";
    var renderShortFooter = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer/* default */.Z, _object_spread({}, props));
    };
    var renderSlimFooter = function() {
        var getFullFooterForLocalized = true;
        var footerComponents = (0,localization_service/* getFooterComponents */.L8)(localeId, abTests, getFullFooterForLocalized, {
            pageClusterConfig: pageClusterConfig,
            useProductMiniSiteConfig: useProductMiniSiteConfig
        });
        var SlimFooterLinks = footerComponents.SlimFooterLinks;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(long_footer_scss/* StyledFooter */.tc, {
            className: classnames_default()("footer-container", "slim-footer"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer-content-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "footer-content",
                        "aria-label": "Footer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "categories-container",
                            children: SlimFooterLinks.map(function(column, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: column.type,
                                        links: column.links,
                                        hasMondayLogoTitle: index === 0
                                    })
                                });
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_bottom_bar_component/* default */.Z, {
                    SocialFooterLinks: links/* SocialFooterLinks */.Ff7,
                    footerType: SLIM_FOOTER
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledDesktopFooterContainer */.w2, {
                className: "footer-desktop-wrapper",
                children: renderSlimFooter()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledMobileFooterContainer */.qJ, {
                className: "footer-mobile-wrapper",
                children: renderShortFooter()
            })
        ]
    });
};
/* harmony default export */ var slim_footer = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(SlimFooter)));
SlimFooter.defaultProps = default_props;


/***/ }),

/***/ 44574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ base_footer_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.js + 1 modules
var long_footer = __webpack_require__(14285);
// EXTERNAL MODULE: ./segments/desktop/core-components/slim-footer/slim-footer.js + 1 modules
var slim_footer = __webpack_require__(53021);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/base-footer/footer-consts.js
var footer_consts = __webpack_require__(99633);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/base-footer/default-props.js
var default_props = __webpack_require__(96564);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/base-footer/base-footer-component.scss.js

var StyledBaseFooterComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1cyjyh50"
})();

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/base-footer/base-footer-component.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}






var BaseFooterComponent = function(props) {
    var _obj;
    var Footer = (_obj = {}, (0,_define_property/* default */.Z)(_obj, footer_consts/* LONG */.F, long_footer/* default */.Z), (0,_define_property/* default */.Z)(_obj, footer_consts/* SLIM */.z, slim_footer/* default */.Z), _obj)[props.footer_type] || slim_footer/* default */.Z;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBaseFooterComponent, {
        className: "base-footer-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, _object_spread({}, props))
    });
};
BaseFooterComponent.defaultProps = default_props/* default */.Z;
/* harmony default export */ var base_footer_component = (BaseFooterComponent);


/***/ }),

/***/ 96564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _footer_consts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99633);

/* harmony default export */ __webpack_exports__["Z"] = ({
    footer_type: _footer_consts__WEBPACK_IMPORTED_MODULE_0__/* .SLIM */ .z
});


/***/ })

}]);